
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("3hOY6", function(module, exports) {

var $kM6CX = parcelRequire("kM6CX");


var $dLCCQ = parcelRequire("dLCCQ");


var $fPe0U = parcelRequire("fPe0U");


var $bX0kj = parcelRequire("bX0kj");


var $9gJAx = parcelRequire("9gJAx");


var $13TeD = parcelRequire("13TeD");


var $2ASIF = parcelRequire("2ASIF");


var $4K6SB = parcelRequire("4K6SB");


var $hsH3d = parcelRequire("hsH3d");


var $hf117 = parcelRequire("hf117");

const $2cf6dc8b1e65c9fe$export$9b5ac10f59f76296 = {
    ClearIndicator: (0, $bX0kj.ClearIndicator),
    Control: (0, $dLCCQ.default),
    DropdownIndicator: (0, $bX0kj.DropdownIndicator),
    Group: (0, $fPe0U.default),
    GroupHeading: (0, $fPe0U.GroupHeading),
    IndicatorsContainer: (0, $kM6CX.IndicatorsContainer),
    Input: (0, $9gJAx.default),
    LoadingIndicator: (0, $bX0kj.LoadingIndicator),
    Menu: (0, $13TeD.default),
    MenuList: (0, $13TeD.MenuList),
    MenuPortal: (0, $13TeD.MenuPortal),
    LoadingMessage: (0, $13TeD.LoadingMessage),
    NoOptionsMessage: (0, $13TeD.NoOptionsMessage),
    MultiValue: (0, $2ASIF.default),
    MultiValueContainer: (0, $2ASIF.MultiValueContainer),
    MultiValueLabel: (0, $2ASIF.MultiValueLabel),
    MultiValueRemove: (0, $2ASIF.MultiValueRemove),
    Option: (0, $4K6SB.default),
    Placeholder: (0, $hsH3d.default),
    SelectContainer: (0, $kM6CX.SelectContainer),
    SingleValue: (0, $hf117.default),
    ValueContainer: (0, $kM6CX.ValueContainer)
};
const $2cf6dc8b1e65c9fe$export$71abc632aa29e6fe = (props)=>({
        ...$2cf6dc8b1e65c9fe$export$9b5ac10f59f76296,
        ...props.components
    });
module.exports["components"] = $2cf6dc8b1e65c9fe$export$9b5ac10f59f76296;
module.exports["defaultComponents"] = $2cf6dc8b1e65c9fe$export$71abc632aa29e6fe;

});

parcelRegister("A6wna", function(module, exports) {
const $ef9a0bb7473fac9e$export$8793edee2d425525 = ()=>{};
// ==============================
// Class Name Prefixer
// ==============================
/**
 * String representation of component state for styling with class names.
 *
 * Expects an array of strings OR a string/object pair:
 * - className(['comp', 'comp-arg', 'comp-arg-2'])
 * @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 * - className('comp', { some: true, state: false })
 * @returns 'react-select__comp react-select__comp--some'
 */ function $ef9a0bb7473fac9e$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $ef9a0bb7473fac9e$export$ce4ab0c55987d1ff(prefix, state, ...classNameList) {
    const arr = [
        ...classNameList
    ];
    if (state && prefix) {
        for(let key in state)if (state.hasOwnProperty(key) && state[key]) arr.push(`${$ef9a0bb7473fac9e$var$applyPrefixToName(prefix, key)}`);
    }
    return arr.filter((i)=>i).map((i)=>String(i).trim()).join(' ');
}
const $ef9a0bb7473fac9e$export$33f062f47f21a01 = (value)=>{
    if ($ef9a0bb7473fac9e$var$isArray(value)) return value.filter(Boolean);
    if (typeof value === 'object' && value !== null) return [
        value
    ];
    return [];
};
const $ef9a0bb7473fac9e$export$8e9fd4287627890c = (props)=>{
    //className
    const { className: className, clearValue: // not listed in commonProps documentation, needs to be removed to allow Emotion to generate classNames
    clearValue, cx: cx, xcss: xcss, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, hasValue: hasValue, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: // not listed in commonProps documentation
    selectOption, selectProps: selectProps, setValue: setValue, ...innerProps } = props;
    return {
        ...innerProps
    };
};
const $ef9a0bb7473fac9e$export$26417cabd806a658 = (props, name, classNamesState)=>{
    const { cx: cx, getStyles: getStyles, getClassNames: getClassNames, className: className } = props;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState ?? {}, getClassNames(name, props), className)
    };
};
function $ef9a0bb7473fac9e$export$2096bae78ecda911(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        const newValue = onInputChange(inputValue, actionMeta);
        if (typeof newValue === 'string') return newValue;
    }
    return inputValue;
}
function $ef9a0bb7473fac9e$export$d8a62a489b442872(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
function $ef9a0bb7473fac9e$export$2e0654fad740d2e4(el) {
    if ($ef9a0bb7473fac9e$export$d8a62a489b442872(el)) return window.innerHeight;
    return el.clientHeight;
}
function $ef9a0bb7473fac9e$export$c4a223a8ba9e4ea5(el) {
    if ($ef9a0bb7473fac9e$export$d8a62a489b442872(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $ef9a0bb7473fac9e$export$3f99968195accfaf(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($ef9a0bb7473fac9e$export$d8a62a489b442872(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
function $ef9a0bb7473fac9e$export$cfa2225e87938781(element) {
    let style = getComputedStyle(element);
    const excludeStaticParent = style.position === 'absolute';
    const overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(let parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
 * @param t: time (elapsed)
 * @param b: initial value
 * @param c: amount of change
 * @param d: duration
 */ function $ef9a0bb7473fac9e$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $ef9a0bb7473fac9e$export$858c30343199f3af(element, to, duration = 200, callback = $ef9a0bb7473fac9e$export$8793edee2d425525) {
    const start = $ef9a0bb7473fac9e$export$c4a223a8ba9e4ea5(element);
    const change = to - start;
    const increment = 10;
    let currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        const val = $ef9a0bb7473fac9e$var$easeOutCubic(currentTime, start, change, duration);
        $ef9a0bb7473fac9e$export$3f99968195accfaf(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
function $ef9a0bb7473fac9e$export$53a0910f038337bd(menuEl, focusedEl) {
    const menuRect = menuEl.getBoundingClientRect();
    const focusedRect = focusedEl.getBoundingClientRect();
    const overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $ef9a0bb7473fac9e$export$3f99968195accfaf(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $ef9a0bb7473fac9e$export$3f99968195accfaf(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
function $ef9a0bb7473fac9e$export$7807c2a424c2f6d1(element) {
    const rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
function $ef9a0bb7473fac9e$export$56963d77dbffdde7() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch  {
        return false;
    }
}
function $ef9a0bb7473fac9e$export$44f917bf91becd01() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch  {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
let $ef9a0bb7473fac9e$var$passiveOptionAccessed = false;
const $ef9a0bb7473fac9e$var$options = {
    get passive () {
        return $ef9a0bb7473fac9e$var$passiveOptionAccessed = true;
    }
};
// check for SSR
const $ef9a0bb7473fac9e$var$w = typeof window !== 'undefined' ? window : {};
if ($ef9a0bb7473fac9e$var$w.addEventListener && $ef9a0bb7473fac9e$var$w.removeEventListener) {
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $ef9a0bb7473fac9e$var$w.addEventListener('p', $ef9a0bb7473fac9e$export$8793edee2d425525, $ef9a0bb7473fac9e$var$options);
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $ef9a0bb7473fac9e$var$w.removeEventListener('p', $ef9a0bb7473fac9e$export$8793edee2d425525, false);
}
const $ef9a0bb7473fac9e$export$b0622a6911dbeaf5 = $ef9a0bb7473fac9e$var$passiveOptionAccessed;
function $ef9a0bb7473fac9e$export$aedb69ff3e31596c(item) {
    return item != null;
}
function $ef9a0bb7473fac9e$var$isArray(arg) {
    return Array.isArray(arg);
}
function $ef9a0bb7473fac9e$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $ef9a0bb7473fac9e$export$dea4763e29237f4c(singleValue) {
    return singleValue;
}
function $ef9a0bb7473fac9e$export$d1ca752ec761b95b(multiValue) {
    return multiValue;
}
const $ef9a0bb7473fac9e$export$4213b25a1c4e877 = (propsObj, ...properties)=>{
    let propsMap = Object.entries(propsObj).filter(([key])=>!properties.includes(key));
    return propsMap.reduce((newProps, [key, val])=>{
        newProps[key] = val;
        return newProps;
    }, {});
};
const $ef9a0bb7473fac9e$export$bf2eda47afa5f369 = (styles)=>{
    const unsupportedSelectors = [
        ':',
        // pseudo-classes/elements
        '[',
        // attribute selectors
        '>',
        // child combinator
        '+',
        // adjacent sibling combinator
        '~',
        // general sibling combinator
        ' ',
        // descendant combinator
        '*',
        // universal selector
        '#',
        // ID selector
        '.',
        // class selector
        '@',
        // at-rules
        '&',
        // parent selector
        '|',
        // namespace separator
        '^',
        // starts with
        '$',
        // ends with
        '=' // equals
    ];
    return Object.keys(styles).reduce((filteredStyles, key)=>{
        if (!unsupportedSelectors.some((selector)=>key.includes(selector))) filteredStyles[key] = styles[key];
        return filteredStyles;
    }, {});
};
module.exports["noop"] = $ef9a0bb7473fac9e$export$8793edee2d425525;
module.exports["classNames"] = $ef9a0bb7473fac9e$export$ce4ab0c55987d1ff;
module.exports["cleanValue"] = $ef9a0bb7473fac9e$export$33f062f47f21a01;
module.exports["cleanCommonProps"] = $ef9a0bb7473fac9e$export$8e9fd4287627890c;
module.exports["getStyleProps"] = $ef9a0bb7473fac9e$export$26417cabd806a658;
module.exports["handleInputChange"] = $ef9a0bb7473fac9e$export$2096bae78ecda911;
module.exports["isDocumentElement"] = $ef9a0bb7473fac9e$export$d8a62a489b442872;
module.exports["normalizedHeight"] = $ef9a0bb7473fac9e$export$2e0654fad740d2e4;
module.exports["getScrollTop"] = $ef9a0bb7473fac9e$export$c4a223a8ba9e4ea5;
module.exports["scrollTo"] = $ef9a0bb7473fac9e$export$3f99968195accfaf;
module.exports["getScrollParent"] = $ef9a0bb7473fac9e$export$cfa2225e87938781;
module.exports["animatedScrollTo"] = $ef9a0bb7473fac9e$export$858c30343199f3af;
module.exports["scrollIntoView"] = $ef9a0bb7473fac9e$export$53a0910f038337bd;
module.exports["getBoundingClientObj"] = $ef9a0bb7473fac9e$export$7807c2a424c2f6d1;
module.exports["isTouchCapable"] = $ef9a0bb7473fac9e$export$56963d77dbffdde7;
module.exports["isMobileDevice"] = $ef9a0bb7473fac9e$export$44f917bf91becd01;
module.exports["supportsPassiveEvents"] = $ef9a0bb7473fac9e$export$b0622a6911dbeaf5;
module.exports["notNullish"] = $ef9a0bb7473fac9e$export$aedb69ff3e31596c;
module.exports["valueTernary"] = $ef9a0bb7473fac9e$export$40fb9515c784cc3b;
module.exports["singleValueAsValue"] = $ef9a0bb7473fac9e$export$dea4763e29237f4c;
module.exports["multiValueAsValue"] = $ef9a0bb7473fac9e$export$d1ca752ec761b95b;
module.exports["removeProps"] = $ef9a0bb7473fac9e$export$4213b25a1c4e877;
module.exports["filterUnsupportedSelectors"] = $ef9a0bb7473fac9e$export$bf2eda47afa5f369;

});

parcelRegister("i0iqW", function(module, exports) {

var $42omo = parcelRequire("42omo");

var $d1b68699d2affbf4$export$2e2bcd8739ae039 = (0, $42omo.useLayoutEffect);
module.exports["default"] = $d1b68699d2affbf4$export$2e2bcd8739ae039;

});

parcelRegister("ggbZE", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $bYRk6 = parcelRequire("bYRk6");

const $a5586dd8087ce3fa$var$withAnalyticsContext = (defaultData)=>(WrappedComponent)=>{
        const WithAnalyticsContext = /*#__PURE__*/ (0, $42omo.forwardRef)(({ analyticsContext: analyticsContext, ...rest }, ref)=>{
            const analyticsData = (0, $42omo.useMemo)(()=>({
                    ...defaultData,
                    ...analyticsContext
                }), [
                analyticsContext
            ]);
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
                data: analyticsData,
                children: /*#__PURE__*/ (0, $l998X.jsx)(WrappedComponent, {
                    ...rest,
                    ref: ref
                })
            });
        });
        WithAnalyticsContext.displayName = `WithAnalyticsContext(${WrappedComponent.displayName || WrappedComponent.name})`;
        return WithAnalyticsContext;
    };
var $a5586dd8087ce3fa$export$2e2bcd8739ae039 = $a5586dd8087ce3fa$var$withAnalyticsContext;
module.exports["default"] = $a5586dd8087ce3fa$export$2e2bcd8739ae039;

});

parcelRegister("9tehW", function(module, exports) {
$parcel$export(module.exports, "useAsync", () => (parcelRequire("gJgOY")).default);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $jb7rL = parcelRequire("jb7rL");


var $gJgOY = parcelRequire("gJgOY");


var $kjDWr = parcelRequire("kjDWr");

const $c4e0b23ec271d805$var$AsyncSelect = /*#__PURE__*/ (0, $42omo.forwardRef)(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
(props, ref)=>{
    // when isAsync is true, options are not provided and async props are used, we will enable async
    const isAsyncEnabledInBaseSelect = props.isAsync && !props.options && (!!props.loadOptions || !!props.defaultOptions);
    const stateManagedProps = (0, $gJgOY.default)(props);
    // when isAsync is falsy or isAsyncEnabledInBaseSelect is true, we use async props, otherwise we use base props
    let selectAsyncProps = !props.isAsync || isAsyncEnabledInBaseSelect ? stateManagedProps : props;
    const selectProps = (0, $kjDWr.default)(selectAsyncProps);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $jb7rL.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c4e0b23ec271d805$export$2e2bcd8739ae039 = $c4e0b23ec271d805$var$AsyncSelect;
module.exports["default"] = $c4e0b23ec271d805$export$2e2bcd8739ae039;

});

parcelRegister("jb7rL", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $9I2p1 = parcelRequire("9I2p1");


var $dh538 = parcelRequire("dh538");


var $1Ywmy = parcelRequire("1Ywmy");


var $3hOY6 = parcelRequire("3hOY6");

/* dummy-input.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $A6wna = parcelRequire("A6wna");

const $8720dadcd61931c8$var$dummyInputStyles = null;
function $8720dadcd61931c8$export$2e2bcd8739ae039({ innerRef: innerRef, ...props }) {
    // Remove animation props not meant for HTML elements
    const filteredProps = (0, $A6wna.removeProps)(props, 'onExited', 'in', 'enter', 'exit', 'appear'); // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
    return /*#__PURE__*/ (0, $l998X.jsx)("input", {
        ref: innerRef,
        className: (0, $gMc0m.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _nd5l1sux _12ji1r31 _1qu2glyw _12y3idpf _1bsbt94y _kqswh2mm _1n5d1j28 _syaz1j28 _1e02p1rm _tzy4idpf _t9ec1kuz",
            "-dummyInput"
        ]),
        ...filteredProps
    });
}

/* required-input.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");





var $ee7An = parcelRequire("ee7An");

const $c529e29bf8540d6a$var$styles = null;
const $c529e29bf8540d6a$var$RequiredInput = ({ name: name, onFocus: onFocus })=>/*#__PURE__*/ (0, $l998X.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        className: (0, $gMc0m.default)([
            "_1bsb1osq _kqswstnw _u7coidpf _rjxpidpf _1e02idpf _tzy4idpf _lcxvglyw",
            "-requiredInput"
        ]),
        onFocus: onFocus,
        value: "",
        onChange: (0, $ee7An.default)
    }); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $c529e29bf8540d6a$export$2e2bcd8739ae039 = $c529e29bf8540d6a$var$RequiredInput;













const $0211107e3935e90f$var$cancelScroll = (event)=>{
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $0211107e3935e90f$export$2e2bcd8739ae039({ isEnabled: isEnabled, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
    const isBottom = (0, $42omo.useRef)(false);
    const isTop = (0, $42omo.useRef)(false);
    const touchStart = (0, $42omo.useRef)(0);
    const scrollTarget = (0, $42omo.useRef)(null);
    const handleEventDelta = (0, $42omo.useCallback)((event, delta)=>{
        if (scrollTarget.current === null) return;
        const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = scrollTarget.current;
        const target = scrollTarget.current;
        const isDeltaPositive = delta > 0;
        const availableScroll = scrollHeight - clientHeight - scrollTop;
        let shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $0211107e3935e90f$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    const onWheel = (0, $42omo.useCallback)((event)=>{
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    const onTouchStart = (0, $42omo.useCallback)((event)=>{
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    const onTouchMove = (0, $42omo.useCallback)((event)=>{
        const deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    const startListening = (0, $42omo.useCallback)((el)=>{
        // bail early if no element is available to attach to
        if (!el) return;
        const notPassive = (0, $A6wna.supportsPassiveEvents) ? {
            passive: false
        } : false;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('wheel', onWheel, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchstart', onTouchStart, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    const stopListening = (0, $42omo.useCallback)((el)=>{
        // bail early if no element is available to detach from
        if (!el) return;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('wheel', onWheel, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchstart', onTouchStart, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        startListening(element);
        return ()=>{
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}





const $9c9aff3c45ae82af$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
const $9c9aff3c45ae82af$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $9c9aff3c45ae82af$var$preventTouchMove(e) {
    e.preventDefault();
}
function $9c9aff3c45ae82af$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $9c9aff3c45ae82af$var$preventInertiaScroll() {
    const top = this.scrollTop;
    const totalScroll = this.scrollHeight;
    const currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $9c9aff3c45ae82af$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
const $9c9aff3c45ae82af$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
let $9c9aff3c45ae82af$var$activeScrollLocks = 0;
const $9c9aff3c45ae82af$var$listenerOptions = {
    capture: false,
    passive: false
};
function $9c9aff3c45ae82af$export$2e2bcd8739ae039({ isEnabled: isEnabled, accountForScrollbars: accountForScrollbars = true }) {
    const originalStyles = (0, $42omo.useRef)({});
    const scrollTarget = (0, $42omo.useRef)(null);
    const addScrollLock = (0, $42omo.useCallback)((touchScrollTarget)=>{
        if (!$9c9aff3c45ae82af$var$canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $9c9aff3c45ae82af$var$STYLE_KEYS.forEach((key)=>{
            const val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $9c9aff3c45ae82af$var$activeScrollLocks < 1) {
            const currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            const clientWidth = document.body ? document.body.clientWidth : 0;
            const adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($9c9aff3c45ae82af$var$LOCK_STYLES).forEach((key)=>{
                const val = $9c9aff3c45ae82af$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = `${adjustedPadding}px`;
        }
        // account for touch devices
        if (target && $9c9aff3c45ae82af$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.addEventListener('touchmove', $9c9aff3c45ae82af$var$preventTouchMove, $9c9aff3c45ae82af$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchstart', $9c9aff3c45ae82af$var$preventInertiaScroll, $9c9aff3c45ae82af$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchmove', $9c9aff3c45ae82af$var$allowTouchMove, $9c9aff3c45ae82af$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $9c9aff3c45ae82af$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    const removeScrollLock = (0, $42omo.useCallback)((touchScrollTarget)=>{
        if (!$9c9aff3c45ae82af$var$canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        // safely decrement active scroll locks
        $9c9aff3c45ae82af$var$activeScrollLocks = Math.max($9c9aff3c45ae82af$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $9c9aff3c45ae82af$var$activeScrollLocks < 1) $9c9aff3c45ae82af$var$STYLE_KEYS.forEach((key)=>{
            const val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $9c9aff3c45ae82af$var$isTouchDevice()) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.removeEventListener('touchmove', $9c9aff3c45ae82af$var$preventTouchMove, $9c9aff3c45ae82af$var$listenerOptions);
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchstart', $9c9aff3c45ae82af$var$preventInertiaScroll, $9c9aff3c45ae82af$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchmove', $9c9aff3c45ae82af$var$allowTouchMove, $9c9aff3c45ae82af$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        addScrollLock(element);
        return ()=>{
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}


const $4d6eae5816d21c55$var$blurSelectInput = (event)=>{
    const element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
function $4d6eae5816d21c55$export$2e2bcd8739ae039({ children: children, lockEnabled: lockEnabled, captureEnabled: captureEnabled = true, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
    const setScrollCaptureTarget = (0, $0211107e3935e90f$export$2e2bcd8739ae039)({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    const setScrollLockTarget = (0, $9c9aff3c45ae82af$export$2e2bcd8739ae039)({
        isEnabled: lockEnabled
    });
    const targetRef = (element)=>{
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            lockEnabled && // eslint-disable-next-line @atlassian/a11y/click-events-have-key-events, @atlassian/a11y/interactive-element-not-keyboard-focusable, @atlassian/a11y/no-static-element-interactions
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                onClick: $4d6eae5816d21c55$var$blurSelectInput,
                style: {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    position: 'fixed',
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetBlockEnd: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetBlockStart: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetInlineEnd: 0,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    insetInlineStart: 0
                }
            }),
            children(targetRef)
        ]
    });
}



var $if5rb = parcelRequire("if5rb");

function $ad100f5db547f4f3$export$17baa7c95b6ba1b8({ isOpen: isOpen, onClose: onClose }) {
    // @ts-ignore - hot-116676
    (0, $if5rb.useNotifyOpenLayerObserver)({
        isOpen: isOpen,
        onClose: onClose
    });
    return null;
}








const $442ba9ea0dcbe6b6$export$a7265767c78f9bae = {
    onChange: (props)=>{
        const { action: action, label: label = '', isDisabled: isDisabled } = props;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return label.length ? `option ${label}, deselected` : '';
            case 'clear':
                return 'All selected options have been cleared.';
            case 'select-option':
                return label.length && !isDisabled ? `option ${label}, selected.` : '';
            default:
                return '';
        }
    },
    onFilter: (props)=>{
        const { inputValue: inputValue, resultsMessage: resultsMessage } = props;
        return inputValue ? `${resultsMessage} for search term ${inputValue}.` : '';
    }
};


/* a11y-text.tsx generated by @compiled/babel-plugin v0.36.1 */ // Assistive text to describe visual elements. Hidden for sighted users.



parcelRequire("42omo");




const $ad27399d492edca1$var$styles = null;
const $ad27399d492edca1$var$A11yText = (props)=>/*#__PURE__*/ (0, $l998X.jsx)("span" // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-classname-prop
    , {
        className: (0, $gMc0m.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _1pbydx66 _ogto7mnp _uiztglyw _o5721q9c",
            "-a11yText"
        ]),
        ...props
    });
var $ad27399d492edca1$export$2e2bcd8739ae039 = $ad27399d492edca1$var$A11yText;


const $304230040a649a89$var$LiveRegion = (props)=>{
    const { ariaSelection: ariaSelection, focusableOptions: focusableOptions, isFocused: isFocused, selectValue: selectValue, selectProps: selectProps, id: id } = props;
    const { ariaLiveMessages: ariaLiveMessages, getOptionLabel: getOptionLabel, inputValue: inputValue, isOptionDisabled: isOptionDisabled, menuIsOpen: menuIsOpen, options: options, screenReaderStatus: screenReaderStatus, isLoading: isLoading } = selectProps;
    const ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    const messages = (0, $42omo.useMemo)(()=>({
            ...(0, $442ba9ea0dcbe6b6$export$a7265767c78f9bae),
            ...ariaLiveMessages || {}
        }), [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    const ariaSelected = (0, $42omo.useMemo)(()=>{
        let message = '';
        if (menuIsOpen) // we don't need to have selected message when the menu is open
        return '';
        if (ariaSelection && messages.onChange) {
            const { option: option, options: selectedOptions, removedValue: removedValue, removedValues: removedValues, value: value } = ariaSelection;
            // select-option when !isMulti does not return option so we assume selected option is value
            const asOption = (val)=>!Array.isArray(val) ? val : null;
            // If there is just one item from the action then get its label
            const selected = removedValue || option || asOption(value);
            const label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            const multiSelected = selectedOptions || removedValues || undefined;
            const labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            if (!label && !labels.length) // return empty string if no labels provided
            return '';
            const onChangeProps = {
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels,
                ...ariaSelection
            };
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel,
        menuIsOpen
    ]);
    const ariaResults = (0, $42omo.useMemo)(()=>{
        let resultsMsg = '';
        if (isLoading) resultsMsg = 'Loading. ';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            const resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        if (options && options.length === 0) resultsMsg = 'No options. ';
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    const isInitialFocus = ariaSelection?.action === 'initial-input-focus';
    const ScreenReaderText = /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("span", {
                id: "aria-selection",
                children: ariaSelected
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("span", {
                id: "aria-results",
                children: ariaResults
            })
        ]
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $ad27399d492edca1$export$2e2bcd8739ae039), {
                id: id,
                children: isInitialFocus && ScreenReaderText
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $ad27399d492edca1$export$2e2bcd8739ae039), {
                "aria-live": ariaLive,
                role: "status",
                children: isFocused && !isInitialFocus && ScreenReaderText
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$304230040a649a89$export$2e2bcd8739ae039 = $304230040a649a89$var$LiveRegion;



var $13TeD = parcelRequire("13TeD");


var $hJzqL = parcelRequire("hJzqL");


var $eKXGE = parcelRequire("eKXGE");




const $b4fab8b1eb2ddac3$export$9c21a3269931e1e6 = {
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $A6wna.isTouchCapable)(),
    captureMenuScroll: !(0, $A6wna.isTouchCapable)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: (0, $hJzqL.createFilter)(),
    formatGroupLabel: (0, $1Ywmy.formatGroupLabel),
    getOptionLabel: (0, $1Ywmy.getOptionLabel),
    getOptionValue: (0, $1Ywmy.getOptionValue),
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: (0, $1Ywmy.isOptionDisabled),
    loadingMessage: ()=>'Loading...',
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $A6wna.isMobileDevice)(),
    noOptionsMessage: ()=>'No options',
    openMenuOnFocus: false,
    openMenuOnClick: true,
    shouldPreventEscapePropagation: false,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: ({ count: count })=>`${count} result${count !== 1 ? 's' : ''} available`,
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    UNSAFE_is_experimental_generic: false,
    shouldKeepInputOnSelect: false
};
function $b4fab8b1eb2ddac3$var$toCategorizedOption(props, option, selectValue, index) {
    const isDisabled = $b4fab8b1eb2ddac3$var$isOptionDisabled(props, option, selectValue);
    const isSelected = $b4fab8b1eb2ddac3$var$isOptionSelected(props, option, selectValue);
    const label = $b4fab8b1eb2ddac3$var$getOptionLabel(props, option);
    const value = $b4fab8b1eb2ddac3$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $b4fab8b1eb2ddac3$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map((groupOrOption, groupOrOptionIndex)=>{
        //@ts-ignore
        if ('options' in groupOrOption) {
            const categorizedOptions = groupOrOption.options.map((option, optionIndex)=>$b4fab8b1eb2ddac3$var$toCategorizedOption(props, option, selectValue, optionIndex)).filter((categorizedOption)=>$b4fab8b1eb2ddac3$var$isFocusable(props, categorizedOption));
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        const categorizedOption = $b4fab8b1eb2ddac3$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $b4fab8b1eb2ddac3$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $A6wna.notNullish));
}
function $b4fab8b1eb2ddac3$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>option.data));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $b4fab8b1eb2ddac3$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>({
                data: option.data,
                id: `${optionId}-${categorizedOption.index}-${option.index}`
            })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: `${optionId}-${categorizedOption.index}`
        });
        return optionsAccumulator;
    }, []);
}
function $b4fab8b1eb2ddac3$var$buildFocusableOptions(props, selectValue) {
    return $b4fab8b1eb2ddac3$var$buildFocusableOptionsFromCategorizedOptions($b4fab8b1eb2ddac3$var$buildCategorizedOptions(props, selectValue));
}
function $b4fab8b1eb2ddac3$var$isFocusable(props, categorizedOption) {
    const { inputValue: inputValue = '' } = props;
    const { data: data, isSelected: isSelected, label: label, value: value } = categorizedOption;
    return (!$b4fab8b1eb2ddac3$var$shouldHideSelectedOptions(props) || !isSelected) && $b4fab8b1eb2ddac3$var$filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $b4fab8b1eb2ddac3$var$getNextFocusedValue(state, nextSelectValue) {
    const { focusedValue: focusedValue, selectValue: lastSelectValue } = state;
    const lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        const nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $b4fab8b1eb2ddac3$var$getNextFocusedOption(state, options) {
    const { focusedOption: lastFocusedOption } = state;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
const $b4fab8b1eb2ddac3$var$getFocusedOptionId = (focusableOptionsWithIds, focusedOption)=>{
    const focusedOptionId = focusableOptionsWithIds.find((option)=>option.data === focusedOption)?.id;
    return focusedOptionId || null;
};
const $b4fab8b1eb2ddac3$var$getOptionLabel = (props, data)=>{
    return props.getOptionLabel(data);
};
const $b4fab8b1eb2ddac3$var$getOptionValue = (props, data)=>{
    return props.getOptionValue(data);
};
function $b4fab8b1eb2ddac3$var$isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $b4fab8b1eb2ddac3$var$isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    const candidate = $b4fab8b1eb2ddac3$var$getOptionValue(props, option);
    return selectValue.some((i)=>$b4fab8b1eb2ddac3$var$getOptionValue(props, i) === candidate);
}
function $b4fab8b1eb2ddac3$var$filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
const $b4fab8b1eb2ddac3$var$shouldHideSelectedOptions = (props)=>{
    const { hideSelectedOptions: hideSelectedOptions, isMulti: isMulti } = props;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
let $b4fab8b1eb2ddac3$var$instanceId = 1;
class $b4fab8b1eb2ddac3$export$2e2bcd8739ae039 extends (0, $42omo.Component) {
    static getDerivedStateFromProps(props, state) {
        const { prevProps: prevProps, clearFocusValueOnUpdate: clearFocusValueOnUpdate, inputIsHiddenAfterUpdate: inputIsHiddenAfterUpdate, ariaSelection: ariaSelection, isFocused: isFocused, prevWasFocused: prevWasFocused, instancePrefix: instancePrefix } = state;
        const { options: options, value: value, menuIsOpen: menuIsOpen, inputValue: inputValue, isMulti: isMulti } = props;
        const selectValue = (0, $A6wna.cleanValue)(value);
        let newMenuOptionsState = {};
        if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
            const focusableOptions = menuIsOpen ? $b4fab8b1eb2ddac3$var$buildFocusableOptions(props, selectValue) : [];
            const focusableOptionsWithIds = menuIsOpen ? $b4fab8b1eb2ddac3$var$buildFocusableOptionsWithIds($b4fab8b1eb2ddac3$var$buildCategorizedOptions(props, selectValue), `${instancePrefix}-option`) : [];
            const focusedValue = clearFocusValueOnUpdate ? $b4fab8b1eb2ddac3$var$getNextFocusedValue(state, selectValue) : null;
            const focusedOption = $b4fab8b1eb2ddac3$var$getNextFocusedOption(state, focusableOptions);
            const focusedOptionId = $b4fab8b1eb2ddac3$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
            newMenuOptionsState = {
                selectValue: selectValue,
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionId,
                focusableOptionsWithIds: focusableOptionsWithIds,
                focusedValue: focusedValue,
                clearFocusValueOnUpdate: false
            };
        }
        // some updates should toggle the state of the input visibility
        const newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
            inputIsHidden: inputIsHiddenAfterUpdate,
            inputIsHiddenAfterUpdate: undefined
        } : {};
        let newAriaSelection = ariaSelection;
        let hasKeptFocus = isFocused && prevWasFocused;
        if (isFocused && !hasKeptFocus) {
            // If `value` or `defaultValue` props are not empty then announce them
            // when the Select is initially focused
            newAriaSelection = {
                value: (0, $A6wna.valueTernary)(isMulti, selectValue, selectValue[0] || null),
                options: selectValue,
                action: 'initial-input-focus'
            };
            hasKeptFocus = !prevWasFocused;
        }
        // If the 'initial-input-focus' action has been set already
        // then reset the ariaSelection to null
        if (ariaSelection?.action === 'initial-input-focus') newAriaSelection = null;
        return {
            ...newMenuOptionsState,
            ...newInputIsHiddenState,
            prevProps: props,
            ariaSelection: newAriaSelection,
            prevWasFocused: hasKeptFocus
        };
    }
    componentDidMount() {
        this.startListeningComposition();
        this.startListeningToTouch();
        if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('scroll', this.onScroll, true);
        if (this.props.autoFocus) this.focusInput();
        // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
        if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $A6wna.scrollIntoView)(this.menuListRef, this.focusedOptionRef);
    }
    componentDidUpdate(prevProps) {
        const { isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
        const { isFocused: isFocused } = this.state;
        if (// ensure focus is restored correctly when the control becomes enabled
        isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
        isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
        if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
        this.setState({
            isFocused: false
        }, this.onMenuClose);
        else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
        this.setState({
            isFocused: true
        });
        // scroll the focused option into view if necessary
        if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
            (0, $A6wna.scrollIntoView)(this.menuListRef, this.focusedOptionRef);
            this.scrollToFocusedOptionOnUpdate = false;
        }
    }
    componentWillUnmount() {
        this.stopListeningComposition();
        this.stopListeningToTouch();
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.removeEventListener('scroll', this.onScroll, true);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
    onMenuOpen() {
        this.props.onMenuOpen();
    }
    onMenuClose() {
        this.onInputChange('', {
            action: 'menu-close',
            prevInputValue: this.props.inputValue
        });
        this.props.onMenuClose();
    }
    onInputChange(newValue, actionMeta) {
        this.props.onInputChange(newValue, actionMeta);
    }
    // ==============================
    // Methods
    // ==============================
    focusInput() {
        if (!this.inputRef) return;
        this.inputRef.focus();
    }
    blurInput() {
        if (!this.inputRef) return;
        this.inputRef.blur();
    }
    openMenu(focusOption) {
        const { selectValue: selectValue, isFocused: isFocused } = this.state;
        const focusableOptions = this.buildFocusableOptions();
        let openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
        if (!this.props.isMulti) {
            const selectedIndex = focusableOptions.indexOf(selectValue[0]);
            if (selectedIndex > -1) openAtIndex = selectedIndex;
        }
        const focusedOption = focusableOptions[openAtIndex];
        // only scroll if the menu isn't already open
        this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
        this.setState({
            inputIsHiddenAfterUpdate: false,
            focusedValue: null,
            focusedOption: focusedOption,
            focusedOptionId: this.getFocusedOptionId(focusedOption)
        }, ()=>this.onMenuOpen());
        (0, $9I2p1.isSafari)() && focusedOption && this.updateInputLabel(this.calculateInputLabel(focusedOption, openAtIndex));
    }
    updateInputLabel(inputLabel) {
        if (inputLabel) {
            this.inputRef?.setAttribute('aria-label', inputLabel);
            setTimeout(()=>{
                const normalizedLabel = this.props['aria-label'] || this.props.label;
                if (normalizedLabel) this.inputRef?.setAttribute('aria-label', normalizedLabel);
                else this.inputRef?.removeAttribute('aria-label');
            }, 500);
        }
    }
    calculateInputLabel(focusedOption, optionIndex) {
        const { options: options } = this.props;
        const isOptionsGrouped = options?.every((obj)=>typeof obj === 'object' && obj !== null && 'options' in obj);
        let inputLabel = this.getOptionLabel(focusedOption);
        const isOptionFocused = (option)=>{
            return this.getOptionLabel(option) === inputLabel;
        };
        const groupData = options?.find((option)=>{
            const groupCandidate = option;
            return groupCandidate.options?.some(isOptionFocused) ?? false;
        });
        if (isOptionsGrouped) {
            const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
            const totalLength = options?.reduce((acc, currentGroup)=>{
                const group = currentGroup;
                acc += group?.options?.length;
                return acc;
            }, 0);
            inputLabel = `${inputLabel}, ${groupData?.label} (${groupOptionIndex + 1} of ${totalLength})`;
        } else inputLabel = `${inputLabel} (${optionIndex + 1} of ${options?.length})`;
        return inputLabel;
    }
    focusValue(direction) {
        const { selectValue: selectValue, focusedValue: focusedValue } = this.state;
        // Only multiselects support value focusing
        if (!this.props.isMulti) return;
        this.setState({
            focusedOption: null
        });
        let focusedIndex = selectValue.indexOf(focusedValue);
        if (!focusedValue) focusedIndex = -1;
        const lastIndex = selectValue.length - 1;
        let nextFocus = -1;
        if (!selectValue.length) return;
        switch(direction){
            case 'previous':
                if (focusedIndex === 0) // don't cycle from the start to the end
                nextFocus = 0;
                else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                nextFocus = lastIndex;
                else nextFocus = focusedIndex - 1;
                break;
            case 'next':
                if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                break;
        }
        this.setState({
            inputIsHidden: nextFocus !== -1,
            focusedValue: selectValue[nextFocus],
            focusedValueId: `${this.getElementId('selected-value')}-${nextFocus}-remove`,
            focusedOption: null,
            focusedOptionId: null
        });
    }
    focusOption(direction = 'first') {
        const { pageSize: pageSize } = this.props;
        const { focusedOption: focusedOption } = this.state;
        const options = this.getFocusableOptions();
        if (!options.length) return;
        let nextFocus = 0; // handles 'first'
        let focusedIndex = options.indexOf(focusedOption);
        if (!focusedOption) focusedIndex = -1;
        if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
        else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
        else if (direction === 'pageup') {
            nextFocus = focusedIndex - pageSize;
            if (nextFocus < 0) nextFocus = 0;
        } else if (direction === 'pagedown') {
            nextFocus = focusedIndex + pageSize;
            if (nextFocus > options.length - 1) nextFocus = options.length - 1;
        } else if (direction === 'last') nextFocus = options.length - 1;
        this.scrollToFocusedOptionOnUpdate = true;
        this.setState({
            focusedOption: options[nextFocus],
            focusedValue: null,
            focusedValueId: null,
            focusedOptionId: this.getFocusedOptionId(options[nextFocus])
        });
    }
    getCommonProps() {
        const { clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, selectOption: selectOption, setValue: setValue, props: props } = this;
        const { isMulti: isMulti, isRtl: isRtl, options: options } = props;
        const hasValue = this.hasValue();
        return {
            clearValue: clearValue,
            cx: cx,
            getStyles: getStyles,
            getClassNames: getClassNames,
            getValue: getValue,
            hasValue: hasValue,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: props,
            setValue: setValue
        };
    }
    hasValue() {
        const { selectValue: selectValue } = this.state;
        return selectValue.length > 0;
    }
    hasOptions() {
        return !!this.getFocusableOptions().length;
    }
    isClearable() {
        const { isClearable: isClearable, isMulti: isMulti } = this.props;
        // single select, by default, IS NOT clearable
        // multi select, by default, IS clearable
        if (isClearable === undefined) return isMulti;
        return isClearable;
    }
    isOptionDisabled(option, selectValue) {
        return $b4fab8b1eb2ddac3$var$isOptionDisabled(this.props, option, selectValue);
    }
    isOptionSelected(option, selectValue) {
        return $b4fab8b1eb2ddac3$var$isOptionSelected(this.props, option, selectValue);
    }
    filterOption(option, inputValue) {
        return $b4fab8b1eb2ddac3$var$filterOption(this.props, option, inputValue);
    }
    formatOptionLabel(data, context) {
        if (typeof this.props.formatOptionLabel === 'function') {
            const { inputValue: inputValue } = this.props;
            const { selectValue: selectValue } = this.state;
            return this.props.formatOptionLabel(data, {
                context: context,
                inputValue: inputValue,
                selectValue: selectValue
            });
        } else return this.getOptionLabel(data);
    }
    formatGroupLabel(data) {
        return this.props.formatGroupLabel(data);
    }
    calculateDescription() {
        const descriptionProp = this.props['aria-describedby'] || this.props.descriptionId;
        const { isMulti: isMulti } = this.props;
        const hasValue = this.state.selectValue.length > 0;
        // Determine base description based on selection state
        const baseDescriptionId = hasValue ? isMulti ? '' : this.getElementId('single-value') : this.getElementId('placeholder');
        // Fast path for single select with no description prop
        if (!isMulti && !descriptionProp) return {
            'aria-describedby': baseDescriptionId
        };
        // Build the describedby string efficiently
        let describedBy = baseDescriptionId;
        // Add description prop if it exists
        if (descriptionProp) describedBy = describedBy ? `${descriptionProp} ${describedBy}` : descriptionProp;
        // For multi-select, always add multi-message ID
        if (isMulti) {
            const multiMessage = this.getElementId('multi-message');
            describedBy = describedBy ? `${describedBy} ${multiMessage}` : multiMessage;
        }
        return {
            'aria-describedby': describedBy
        };
    }
    // ==============================
    // Composition Handlers
    // ==============================
    startListeningComposition() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionstart', this.onCompositionStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionend', this.onCompositionEnd, false);
        }
    }
    stopListeningComposition() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionstart', this.onCompositionStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionend', this.onCompositionEnd);
        }
    }
    // ==============================
    // Touch Handlers
    // ==============================
    startListeningToTouch() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchstart', this.onTouchStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchmove', this.onTouchMove, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchend', this.onTouchEnd, false);
        }
    }
    stopListeningToTouch() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchstart', this.onTouchStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchmove', this.onTouchMove);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchend', this.onTouchEnd);
        }
    }
    // ==============================
    // Renderers
    // ==============================
    renderInput() {
        const { form: form, inputId: inputId, inputValue: inputValue, isDisabled: isDisabled, isInvalid: isInvalid, isRequired: isRequired, isSearchable: isSearchable, label: label, labelId: labelId, menuIsOpen: menuIsOpen, required: required, tabIndex: tabIndex = 0, testId: testId } = this.props;
        const { Input: Input } = this.getComponents();
        const { inputIsHidden: inputIsHidden } = this.state;
        const { commonProps: commonProps } = this;
        const id = inputId || this.getElementId('input');
        // aria attributes makes the JSX "noisy", separated for clarity
        const ariaAttributes = {
            ...!this.props.isSearchable && (0, $dh538.fg)('platform_fix_autocomplete_aria_for_select') ? {} : {
                'aria-autocomplete': 'both'
            },
            'aria-errormessage': this.props['aria-errormessage'],
            'aria-expanded': menuIsOpen,
            // TODO: aria-haspopup is implied as listbox with role="combobox" and was deprecated for aria 1.2, we still might need to keep it for back compat
            'aria-haspopup': this.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox',
            'aria-invalid': this.props['aria-invalid'] || isInvalid,
            'aria-label': this.props['aria-label'] || label,
            'aria-labelledby': this.props['aria-labelledby'] || labelId,
            'aria-required': required || isRequired,
            role: 'combobox',
            'aria-activedescendant': this.props['UNSAFE_is_experimental_generic'] ? undefined : this.state.focusedOptionId || this.state.focusedValueId || undefined,
            ...menuIsOpen && {
                'aria-controls': this.getElementId('listbox')
            },
            // TODO: Might need to remove this
            ...!isSearchable && {
                'aria-readonly': true
            },
            ...this.calculateDescription()
        };
        if (!isSearchable) // use a dummy input to maintain focus/blur functionality
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $8720dadcd61931c8$export$2e2bcd8739ae039), {
            id: id,
            innerRef: this.getInputRef,
            onBlur: this.onInputBlur,
            onChange: (0, $A6wna.noop),
            onFocus: this.onInputFocus,
            disabled: isDisabled,
            tabIndex: tabIndex,
            inputMode: "none",
            form: form,
            value: "",
            "data-testid": testId && `${testId}-select--input`,
            ...ariaAttributes
        });
        // NOTE: Don't add the `name` prop to this Input, `name` is already a prop on the hidden input element that has the value of the select.
        // Adding `name` to this Input will cause unexpected behavior.
        return /*#__PURE__*/ (0, $l998X.jsx)(Input, {
            ...commonProps,
            autoCapitalize: "none",
            autoComplete: "off",
            autoCorrect: "off",
            id: id,
            testId: testId,
            innerRef: this.getInputRef,
            isDisabled: isDisabled,
            isHidden: inputIsHidden,
            onBlur: this.onInputBlur,
            onChange: this.handleInputChange,
            onFocus: this.onInputFocus,
            spellCheck: "false",
            tabIndex: tabIndex,
            form: form,
            type: "text",
            value: inputValue,
            ...ariaAttributes
        });
    }
    renderPlaceholderOrValue() {
        const { MultiValue: MultiValue, MultiValueContainer: MultiValueContainer, MultiValueLabel: MultiValueLabel, MultiValueRemove: MultiValueRemove, SingleValue: SingleValue, Placeholder: Placeholder } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { controlShouldRenderValue: controlShouldRenderValue, isDisabled: isDisabled, isMulti: isMulti, inputValue: inputValue, placeholder: placeholder, testId: testId } = this.props;
        const { selectValue: selectValue, focusedValue: focusedValue, isFocused: isFocused } = this.state;
        if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ (0, $42omo.createElement)(Placeholder, {
            ...commonProps,
            key: "placeholder",
            isDisabled: isDisabled,
            isFocused: isFocused,
            innerProps: {
                id: this.getElementId('placeholder'),
                ...testId && {
                    'data-testid': `${testId}-select--placeholder`
                }
            }
        }, placeholder);
        if (isMulti) return selectValue.map((opt, index)=>{
            const isOptionFocused = opt === focusedValue;
            const key = `${this.getOptionLabel(opt)}-${this.getOptionValue(opt)}`;
            return /*#__PURE__*/ (0, $42omo.createElement)(MultiValue, {
                ...commonProps,
                components: {
                    Container: MultiValueContainer,
                    Label: MultiValueLabel,
                    Remove: MultiValueRemove
                },
                isFocused: isOptionFocused,
                isDisabled: isDisabled,
                key: key,
                index: index,
                removeProps: {
                    onClick: ()=>this.removeValue(opt),
                    onTouchEnd: ()=>this.removeValue(opt),
                    onMouseDown: (e)=>{
                        e.preventDefault();
                    },
                    ...testId && {
                        'data-testid': `${testId}-select--multivalue-${index}-remove`
                    },
                    id: `${this.getElementId('selected-value')}-${index}-remove`
                },
                data: opt,
                innerProps: {
                    ...testId && {
                        'data-testid': `${testId}-select--multivalue-${index}`
                    },
                    id: `${this.getElementId('selected-value')}-${index}`
                }
            }, this.formatOptionLabel(opt, 'value'));
        });
        if (inputValue) return null;
        const singleValue = selectValue[0];
        return /*#__PURE__*/ (0, $l998X.jsx)(SingleValue, {
            ...commonProps,
            data: singleValue,
            isDisabled: isDisabled,
            innerProps: {
                id: this.getElementId('single-value')
            },
            children: this.formatOptionLabel(singleValue, 'value')
        });
    }
    renderClearIndicator() {
        const { ClearIndicator: ClearIndicator } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { clearControlLabel: clearControlLabel, isDisabled: isDisabled, isLoading: isLoading, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
        const innerProps = {
            onMouseDown: this.onClearIndicatorMouseDown,
            onTouchEnd: this.onClearIndicatorTouchEnd,
            ...testId && {
                'data-testid': `${testId}-select--clear-indicator`
            }
        };
        const isCompact = spacing === 'compact';
        return /*#__PURE__*/ (0, $l998X.jsx)(ClearIndicator, {
            clearControlLabel: clearControlLabel,
            ...commonProps,
            innerProps: innerProps,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderLoadingIndicator() {
        const { LoadingIndicator: LoadingIndicator } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled, isLoading: isLoading, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        if (!LoadingIndicator || !isLoading) return null;
        const isCompact = spacing === 'compact';
        const innerProps = {
            'aria-hidden': 'true'
        };
        return /*#__PURE__*/ (0, $l998X.jsx)(LoadingIndicator, {
            "data-testid": testId && `${testId}-select--loading-indicator`,
            ...commonProps,
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderDropdownIndicator() {
        const { DropdownIndicator: DropdownIndicator } = this.getComponents();
        if (!DropdownIndicator) return null;
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled, spacing: spacing, testId: testId } = this.props;
        const { isFocused: isFocused } = this.state;
        const isCompact = spacing === 'compact';
        const innerProps = {
            onMouseDown: this.onDropdownIndicatorMouseDown,
            onTouchEnd: this.onDropdownIndicatorTouchEnd,
            'aria-hidden': 'true',
            ...testId && {
                'data-testid': `${testId}-select--dropdown-indicator`
            }
        };
        return /*#__PURE__*/ (0, $l998X.jsx)(DropdownIndicator, {
            ...commonProps,
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isCompact: isCompact
        });
    }
    renderMenu() {
        const { Group: Group, GroupHeading: GroupHeading, Menu: Menu, MenuList: MenuList, MenuPortal: MenuPortal, LoadingMessage: LoadingMessage, NoOptionsMessage: NoOptionsMessage, Option: Option } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { focusedOption: focusedOption } = this.state;
        const { captureMenuScroll: captureMenuScroll, inputValue: inputValue, isLoading: isLoading, loadingMessage: loadingMessage, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuIsOpen: menuIsOpen, menuPlacement: menuPlacement, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, menuShouldBlockScroll: menuShouldBlockScroll, menuShouldScrollIntoView: menuShouldScrollIntoView, noOptionsMessage: noOptionsMessage, onMenuScrollToTop: onMenuScrollToTop, onMenuScrollToBottom: onMenuScrollToBottom, testId: testId } = this.props;
        if (!menuIsOpen) return null;
        // TODO: Internal Option Type here
        const render = (props, id, headingId)=>{
            const { type: type, data: data, isDisabled: isDisabled, isSelected: isSelected, label: label, value: value } = props;
            const isFocused = focusedOption === data;
            const onHover = isDisabled ? undefined : ()=>this.onOptionHover(data);
            const onSelect = isDisabled ? undefined : ()=>this.selectOption(data);
            const optionId = `${this.getElementId('option')}-${id}`;
            const innerProps = {
                id: optionId,
                onClick: onSelect,
                onMouseMove: onHover,
                onMouseOver: onHover,
                role: this.props['UNSAFE_is_experimental_generic'] ? 'listitem' : 'option',
                'aria-selected': this.props['UNSAFE_is_experimental_generic'] ? undefined : isSelected,
                // We don't want aria-disabled if it's false. It's just noisy.
                'aria-disabled': !isDisabled ? undefined : isDisabled,
                'aria-describedby': headingId,
                ...testId && {
                    'data-testid': `${testId}-select--option-${id}`
                }
            };
            return /*#__PURE__*/ (0, $42omo.createElement)(Option, {
                ...commonProps,
                innerProps: innerProps,
                data: data,
                isDisabled: isDisabled,
                isSelected: isSelected,
                key: optionId,
                label: label,
                type: type,
                value: value,
                isFocused: isFocused,
                innerRef: isFocused ? this.getFocusedOptionRef : undefined
            }, this.formatOptionLabel(props.data, 'menu'));
        };
        let menuUI;
        if (this.hasOptions()) {
            const items = this.getCategorizedOptions();
            menuUI = items.map((item)=>{
                if (item.type === 'group') {
                    const { data: data, options: options, index: groupIndex } = item;
                    const groupId = `${this.getElementId('group')}-${groupIndex}`;
                    const headingId = `${groupId}-heading`;
                    return /*#__PURE__*/ (0, $42omo.createElement)(Group, {
                        ...commonProps,
                        key: groupId,
                        data: data,
                        options: options,
                        Heading: GroupHeading,
                        headingProps: {
                            id: headingId,
                            data: item.data,
                            ...testId && {
                                'data-testid': `${testId}-select--group-${groupIndex}-heading`
                            }
                        },
                        label: this.formatGroupLabel(item.data)
                    }, item.options.map((option)=>render(option, `${groupIndex}-${option.index}`, headingId)));
                } else if (item.type === 'option') return render(item, `${item.index}`);
                return undefined;
            });
        } else if (isLoading) {
            const message = loadingMessage({
                inputValue: inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, $l998X.jsx)(LoadingMessage, {
                ...commonProps,
                children: message
            });
        } else {
            const message = noOptionsMessage({
                inputValue: inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, $l998X.jsx)(NoOptionsMessage, {
                ...commonProps,
                innerProps: {
                    ...this.props['UNSAFE_is_experimental_generic'] && {
                        role: 'listitem'
                    },
                    ...testId && {
                        'data-testid': `${testId}-select--no-options`
                    }
                },
                children: message
            });
        }
        const menuPlacementProps = {
            minMenuHeight: minMenuHeight,
            maxMenuHeight: maxMenuHeight,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            menuShouldScrollIntoView: menuShouldScrollIntoView
        };
        const menuElement = /*#__PURE__*/ (0, $l998X.jsx)((0, $13TeD.MenuPlacer), {
            ...commonProps,
            ...menuPlacementProps,
            children: ({ ref: ref, placerProps: { placement: placement, maxHeight: maxHeight } })=>/*#__PURE__*/ (0, $l998X.jsx)(Menu, {
                    ...commonProps,
                    ...menuPlacementProps,
                    innerRef: ref,
                    innerProps: {
                        onMouseDown: this.onMenuMouseDown,
                        onMouseMove: this.onMenuMouseMove,
                        id: this.props.components.Menu ? this.getElementId('listbox') : undefined,
                        ...testId && {
                            'data-testid': `${testId}-select--listbox-container`
                        }
                    },
                    isLoading: isLoading,
                    placement: placement,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $4d6eae5816d21c55$export$2e2bcd8739ae039), {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll,
                        children: (scrollTargetRef)=>/*#__PURE__*/ (0, $l998X.jsx)(MenuList, {
                                ...commonProps,
                                innerRef: (instance)=>{
                                    this.getMenuListRef(instance);
                                    scrollTargetRef(instance);
                                },
                                innerProps: {
                                    role: this.props['UNSAFE_is_experimental_generic'] ? 'dialog' : 'listbox',
                                    ...this.props['UNSAFE_is_experimental_generic'] && {
                                        'aria-labelledby': this.inputRef?.id || this.getElementId('input')
                                    },
                                    'aria-multiselectable': !commonProps.isMulti || this.props['UNSAFE_is_experimental_generic'] ? undefined : commonProps.isMulti,
                                    id: this.getElementId('listbox'),
                                    ...testId && {
                                        'data-testid': `${testId}-select--listbox`
                                    },
                                    // add aditional label on listbox for safari to announce first option
                                    ...(0, $9I2p1.isSafari)() && !this.props['UNSAFE_is_experimental_generic'] && {
                                        'aria-describedby': this.inputRef?.id || this.getElementId('input')
                                    }
                                },
                                isLoading: isLoading,
                                maxHeight: maxHeight,
                                focusedOption: focusedOption,
                                children: this.props['UNSAFE_is_experimental_generic'] ? /*#__PURE__*/ (0, $l998X.jsx)("div", {
                                    role: "list",
                                    children: menuUI
                                }) : menuUI
                            })
                    })
                })
        });
        // positioning behaviour is almost identical for portalled and fixed,
        // so we use the same component. the actual portalling logic is forked
        // within the component based on `menuPosition`
        return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ (0, $l998X.jsx)(MenuPortal, {
            ...commonProps,
            appendTo: menuPortalTarget,
            controlElement: this.controlRef,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            children: menuElement
        }) : menuElement;
    }
    renderFormField() {
        const { delimiter: delimiter, isDisabled: isDisabled, isMulti: isMulti, required: required, name: name } = this.props;
        const { selectValue: selectValue } = this.state;
        if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ (0, $l998X.jsx)((0, $c529e29bf8540d6a$export$2e2bcd8739ae039), {
            name: name,
            onFocus: this.onValueInputFocus
        });
        if (!name || isDisabled) return;
        if (isMulti) {
            if (delimiter) {
                const value = selectValue.map((opt)=>this.getOptionValue(opt)).join(delimiter);
                return /*#__PURE__*/ (0, $l998X.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: value
                });
            } else {
                const input = selectValue.length > 0 ? selectValue.map((opt, i)=>/*#__PURE__*/ (0, $l998X.jsx)("input", {
                        name: name,
                        type: "hidden",
                        value: this.getOptionValue(opt)
                    }, `i-${i}`)) : /*#__PURE__*/ (0, $l998X.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: ""
                });
                return /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    children: input
                });
            }
        } else {
            const value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
            return /*#__PURE__*/ (0, $l998X.jsx)("input", {
                name: name,
                type: "hidden",
                value: value
            });
        }
    }
    renderLiveRegion() {
        const { commonProps: commonProps } = this;
        const { ariaSelection: ariaSelection, isFocused: isFocused, selectValue: selectValue } = this.state;
        const focusableOptions = this.getFocusableOptions();
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $304230040a649a89$export$2e2bcd8739ae039), {
            ...commonProps,
            id: this.getElementId('live-region'),
            ariaSelection: ariaSelection,
            isFocused: isFocused,
            selectValue: selectValue,
            focusableOptions: focusableOptions
        });
    }
    renderMultiselectMessage() {
        // In the future, when we actually support touch devices, we'll need to update this to not be keyboard specific.
        // Also, since this is rendered onscreen, it should be transtlated automatically.
        const msg = `, multiple selections available, ${this.state.selectValue.length ? 'Use left or right arrow keys to navigate selected items' : ''}`;
        return(// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        /*#__PURE__*/ (0, $l998X.jsx)("span", {
            id: this.getElementId('multi-message'),
            hidden: true,
            children: msg
        }));
    }
    render() {
        const { Control: Control, IndicatorsContainer: IndicatorsContainer, SelectContainer: SelectContainer, ValueContainer: ValueContainer } = this.getComponents();
        const { className: className, id: id, isDisabled: isDisabled, menuIsOpen: menuIsOpen, isInvalid: isInvalid, testId: testId, appearance: appearance = 'default', spacing: spacing = 'default' } = this.props;
        const { isFocused: isFocused } = this.state;
        const commonProps = this.commonProps = this.getCommonProps();
        const isCompact = spacing === 'compact';
        return /*#__PURE__*/ (0, $l998X.jsxs)(SelectContainer, {
            ...commonProps,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            innerProps: {
                id: id,
                onKeyDown: this.onKeyDown,
                ...testId && {
                    'data-testid': testId && `${testId}-select--container`
                }
            },
            isDisabled: isDisabled,
            isFocused: isFocused,
            children: [
                this.renderLiveRegion(),
                commonProps.isMulti && this.renderMultiselectMessage(),
                /*#__PURE__*/ (0, $l998X.jsxs)(Control, {
                    ...commonProps,
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd,
                        ...testId && {
                            'data-testid': `${testId}-select--control`
                        }
                    },
                    appearance: appearance,
                    isInvalid: isInvalid,
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen,
                    isCompact: isCompact,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsxs)(ValueContainer, {
                            ...commonProps,
                            isDisabled: isDisabled,
                            isCompact: isCompact,
                            innerProps: {
                                ...testId && {
                                    'data-testid': `${testId}-select--value-container`
                                },
                                ...commonProps.isMulti && commonProps.hasValue && !(0, $9I2p1.isAppleDevice)() && {
                                    // Required to keep JAWS from popping out of forms mode when using LEFT/RIGHT arrow keys.
                                    // This is Jedi Master level ARIA and not taken lightly. Do not modify without consulting
                                    // DST Accessibility.
                                    role: 'application'
                                }
                            },
                            children: [
                                this.renderPlaceholderOrValue(),
                                this.renderInput()
                            ]
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)(IndicatorsContainer, {
                            ...commonProps,
                            isDisabled: isDisabled,
                            innerProps: {
                                ...testId && {
                                    'data-testid': `${testId}-select--indicators-container`
                                }
                            },
                            children: [
                                this.renderClearIndicator(),
                                this.renderLoadingIndicator(),
                                this.renderDropdownIndicator()
                            ]
                        })
                    ]
                }),
                this.renderMenu(),
                this.renderFormField(),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $ad100f5db547f4f3$export$17baa7c95b6ba1b8), {
                    isOpen: this.props.menuIsOpen,
                    onClose: this.handleOpenLayerObserverCloseSignal
                })
            ]
        });
    }
    // Lifecycle
    // ------------------------------
    constructor(_props){
        super(_props);
        this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            focusedValueId: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ''
        };
        // Misc. Instance Properties
        // ------------------------------
        this.blockOptionHover = false;
        this.isComposing = false;
        this.commonProps = void 0;
        // TODO
        this.initialTouchX = 0;
        this.initialTouchY = 0;
        this.openAfterFocus = false;
        this.scrollToFocusedOptionOnUpdate = false;
        this.userIsDragging = void 0;
        // Refs
        // ------------------------------
        this.controlRef = null;
        this.getControlRef = (ref)=>{
            this.controlRef = ref;
        };
        this.focusedOptionRef = null;
        this.getFocusedOptionRef = (ref)=>{
            this.focusedOptionRef = ref;
        };
        this.menuListRef = null;
        this.getMenuListRef = (ref)=>{
            this.menuListRef = ref;
        };
        this.inputRef = null;
        this.getInputRef = (ref)=>{
            this.inputRef = ref;
        };
        // aliased for consumers
        this.focus = this.focusInput;
        this.blur = this.blurInput;
        this.onChange = (newValue, actionMeta)=>{
            const { onChange: onChange, name: name } = this.props;
            actionMeta.name = name;
            this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        this.setValue = (newValue, action, option)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, isMulti: isMulti, inputValue: inputValue, shouldKeepInputOnSelect: shouldKeepInputOnSelect } = this.props;
            // for multiple selection options, do not clear the search input value
            if (isMulti && shouldKeepInputOnSelect && (0, $dh538.fg)('platform_do_not_clear_input_for_multiselect')) this.onInputChange(inputValue, {
                action: 'set-value',
                prevInputValue: inputValue
            });
            else this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            this.setState({
                clearFocusValueOnUpdate: true
            });
            this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        this.selectOption = (newValue)=>{
            const { blurInputOnSelect: blurInputOnSelect, isMulti: isMulti, name: name } = this.props;
            const { selectValue: selectValue } = this.state;
            const deselected = isMulti && this.isOptionSelected(newValue, selectValue);
            const isDisabled = this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                const candidate = this.getOptionValue(newValue);
                this.setValue((0, $A6wna.multiValueAsValue)(selectValue.filter((i)=>this.getOptionValue(i) !== candidate)), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) this.setValue((0, $A6wna.multiValueAsValue)([
                    ...selectValue,
                    newValue
                ]), 'select-option', newValue);
                else this.setValue((0, $A6wna.singleValueAsValue)(newValue), 'select-option');
            } else {
                this.ariaOnChange((0, $A6wna.singleValueAsValue)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) this.blurInput();
        };
        this.removeValue = (removedValue)=>{
            const { isMulti: isMulti } = this.props;
            const { selectValue: selectValue } = this.state;
            const candidate = this.getOptionValue(removedValue);
            const newValueArray = selectValue.filter((i)=>this.getOptionValue(i) !== candidate);
            const newValue = (0, $A6wna.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            this.focusInput();
        };
        this.clearValue = ()=>{
            const { selectValue: selectValue } = this.state;
            this.onChange((0, $A6wna.valueTernary)(this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        };
        this.popValue = ()=>{
            const { isMulti: isMulti } = this.props;
            const { selectValue: selectValue } = this.state;
            const lastSelectedValue = selectValue[selectValue.length - 1];
            const newValueArray = selectValue.slice(0, selectValue.length - 1);
            const newValue = (0, $A6wna.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        // ==============================
        // Getters
        // ==============================
        this.getFocusedOptionId = (focusedOption)=>{
            return $b4fab8b1eb2ddac3$var$getFocusedOptionId(this.state.focusableOptionsWithIds, focusedOption);
        };
        this.getFocusableOptionsWithIds = ()=>{
            return $b4fab8b1eb2ddac3$var$buildFocusableOptionsWithIds($b4fab8b1eb2ddac3$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getElementId('option'));
        };
        this.getValue = ()=>this.state.selectValue;
        this.cx = (...args)=>(0, $A6wna.classNames)(this.props.classNamePrefix, ...args);
        this.getOptionLabel = (data)=>{
            return $b4fab8b1eb2ddac3$var$getOptionLabel(this.props, data);
        };
        this.getOptionValue = (data)=>{
            return $b4fab8b1eb2ddac3$var$getOptionValue(this.props, data);
        };
        this.getStyles = (key, props)=>{
            const base = (0, $eKXGE.defaultStyles)[key](props);
            base.boxSizing = 'border-box';
            const custom = this.props.styles[key];
            if (!custom) return base;
            const customStyles = (0, $A6wna.filterUnsupportedSelectors)(custom(base, props));
            return customStyles;
        };
        this.getClassNames = (key, props)=>this.props.classNames[key]?.(props);
        this.getElementId = (element)=>{
            return `${this.state.instancePrefix}-${element}`;
        };
        this.getComponents = ()=>{
            return (0, $3hOY6.defaultComponents)(this.props);
        };
        this.buildCategorizedOptions = ()=>$b4fab8b1eb2ddac3$var$buildCategorizedOptions(this.props, this.state.selectValue);
        this.getCategorizedOptions = ()=>this.props.menuIsOpen ? this.buildCategorizedOptions() : [];
        this.buildFocusableOptions = ()=>$b4fab8b1eb2ddac3$var$buildFocusableOptionsFromCategorizedOptions(this.buildCategorizedOptions());
        this.getFocusableOptions = ()=>this.props.menuIsOpen ? this.buildFocusableOptions() : [];
        // ==============================
        // Helpers
        // ==============================
        this.ariaOnChange = (value, actionMeta)=>{
            this.setState({
                ariaSelection: {
                    value: value,
                    ...actionMeta
                }
            });
        };
        // ==============================
        // Mouse Handlers
        // ==============================
        this.onMenuMouseDown = (event)=>{
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            this.focusInput();
        };
        this.onMenuMouseMove = (_)=>{
            this.blockOptionHover = false;
        };
        this.onControlMouseDown = (event)=>{
            // Event captured by dropdown indicator
            if (event.defaultPrevented) {
                // react-dnd will fire preventDefault in mouseDown, which make select is not clickable.
                // temp workaround to check if select is within dnd, we don't do the early return.
                if (!this.controlRef?.closest('[data-rbd-draggable-context-id]')) return;
            }
            const { openMenuOnClick: openMenuOnClick } = this.props;
            if (!this.state.isFocused) {
                if (openMenuOnClick) this.openAfterFocus = true;
                this.focusInput();
            } else if (!this.props.menuIsOpen) {
                if (openMenuOnClick) this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        this.onDropdownIndicatorMouseDown = (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (this.props.isDisabled) return;
            const { isMulti: isMulti, menuIsOpen: menuIsOpen } = this.props;
            this.focusInput();
            if (menuIsOpen) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            } else this.openMenu('first');
            event.preventDefault();
        };
        this.onClearIndicatorMouseDown = (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            this.clearValue();
            event.preventDefault();
            this.openAfterFocus = false;
            if (event.type === 'touchend') this.focusInput();
            else setTimeout(()=>this.focusInput());
        };
        this.onScroll = (event)=>{
            if (typeof this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $A6wna.isDocumentElement)(event.target)) this.props.onMenuClose();
            } else if (typeof this.props.closeMenuOnScroll === 'function') {
                if (this.props.closeMenuOnScroll(event)) this.props.onMenuClose();
            }
        };
        this.onCompositionStart = ()=>{
            this.isComposing = true;
        };
        this.onCompositionEnd = ()=>{
            this.isComposing = false;
        };
        this.onTouchStart = ({ touches: touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            this.initialTouchX = touch.clientX;
            this.initialTouchY = touch.clientY;
            this.userIsDragging = false;
        };
        this.onTouchMove = ({ touches: touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            const deltaX = Math.abs(touch.clientX - this.initialTouchX);
            const deltaY = Math.abs(touch.clientY - this.initialTouchY);
            const moveThreshold = 5;
            this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        this.onTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (this.controlRef && !this.controlRef.contains(event.target) && this.menuListRef && !this.menuListRef.contains(event.target)) this.blurInput();
            // reset move vars
            this.initialTouchX = 0;
            this.initialTouchY = 0;
        };
        this.onControlTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onControlMouseDown(event);
        };
        this.onClearIndicatorTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onClearIndicatorMouseDown(event);
        };
        this.onDropdownIndicatorTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onDropdownIndicatorMouseDown(event);
        };
        // ==============================
        // Focus Handlers
        // ==============================
        this.handleInputChange = (event)=>{
            const { inputValue: prevInputValue } = this.props;
            const inputValue = event.currentTarget.value;
            this.setState({
                inputIsHiddenAfterUpdate: false
            });
            this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!this.props.menuIsOpen) this.onMenuOpen();
        };
        this.onInputFocus = (event)=>{
            if (this.props.onFocus) this.props.onFocus(event);
            this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (this.openAfterFocus || this.props.openMenuOnFocus) this.openMenu('first');
            this.openAfterFocus = false;
        };
        this.onInputBlur = (event)=>{
            const { inputValue: prevInputValue } = this.props;
            if (this.menuListRef && this.menuListRef.contains(document.activeElement)) {
                this.inputRef.focus();
                return;
            }
            if (this.props.onBlur) this.props.onBlur(event);
            this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            if ((0, $dh538.fg)('platform_dst_select_menu_close_on_blur')) // when fg is enabled, we only call onMenuClose when this.props.menuIsOpen is true.
            this.props.menuIsOpen && this.onMenuClose();
            else this.onMenuClose();
            this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        this.onOptionHover = (focusedOption)=>{
            if (this.blockOptionHover || this.state.focusedOption === focusedOption) return;
            const options = this.getFocusableOptions();
            const focusedOptionIndex = options.indexOf(focusedOption);
            this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? this.getFocusedOptionId(focusedOption) : null
            });
        };
        this.shouldHideSelectedOptions = ()=>{
            return $b4fab8b1eb2ddac3$var$shouldHideSelectedOptions(this.props);
        };
        // If the hidden input gets focus through form submit,
        // redirect focus to focusable input.
        this.onValueInputFocus = (e)=>{
            e.preventDefault();
            e.stopPropagation();
            this.focus();
        };
        // ==============================
        // Keyboard Handlers
        // ==============================
        this.onKeyDown = (event)=>{
            const { isMulti: isMulti, backspaceRemovesValue: backspaceRemovesValue, escapeClearsValue: escapeClearsValue, inputValue: inputValue, isClearable: isClearable, isDisabled: isDisabled, menuIsOpen: menuIsOpen, onKeyDown: onKeyDown, tabSelectsValue: tabSelectsValue, openMenuOnFocus: openMenuOnFocus, shouldPreventEscapePropagation: shouldPreventEscapePropagation } = this.props;
            const { focusedOption: focusedOption, focusedValue: focusedValue, selectValue: selectValue } = this.state;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) this.popValue();
                        else if (isClearable) this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && this.isOptionSelected(focusedOption, selectValue)) return;
                    this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (focusedValue) this.removeValue(focusedValue);
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (this.isComposing) return;
                        this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        this.onMenuClose();
                        if (shouldPreventEscapePropagation && event.target instanceof HTMLElement) event.stopPropagation();
                    } else if (isClearable && escapeClearsValue) this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) this.focusOption('up');
                    else this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) this.focusOption('down');
                    else this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        this.handleOpenLayerObserverCloseSignal = ()=>{
            this.onMenuClose();
        };
        this.state.instancePrefix = 'react-select-' + (this.props.instanceId || ++$b4fab8b1eb2ddac3$var$instanceId);
        this.state.selectValue = (0, $A6wna.cleanValue)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen) {
            const focusableOptionsWithIds = this.getFocusableOptionsWithIds();
            const focusableOptions = this.buildFocusableOptions();
            const optionIndex = focusableOptions.indexOf(this.state.selectValue[0]);
            this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            this.state.focusedOption = focusableOptions[optionIndex];
            this.state.focusedOptionId = $b4fab8b1eb2ddac3$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
    }
}
$b4fab8b1eb2ddac3$export$2e2bcd8739ae039.defaultProps = $b4fab8b1eb2ddac3$export$9c21a3269931e1e6;
module.exports["default"] = $b4fab8b1eb2ddac3$export$2e2bcd8739ae039;

});

parcelRegister("1Ywmy", function(module, exports) {
/* eslint-disable @repo/internal/fs/filename-pattern-match */ const $5c60f9082494b8c0$export$f4da216a6ca54656 = (group)=>group.label;
const $5c60f9082494b8c0$export$dac6ace3020563ca = (option)=>option.label;
const $5c60f9082494b8c0$export$40be908210c5a79c = (option)=>option.value;
const $5c60f9082494b8c0$export$56bd0c8d90db075 = (option)=>!!option.isDisabled;
module.exports["formatGroupLabel"] = $5c60f9082494b8c0$export$f4da216a6ca54656;
module.exports["getOptionLabel"] = $5c60f9082494b8c0$export$dac6ace3020563ca;
module.exports["getOptionValue"] = $5c60f9082494b8c0$export$40be908210c5a79c;
module.exports["isOptionDisabled"] = $5c60f9082494b8c0$export$56bd0c8d90db075;

});

parcelRegister("hJzqL", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");

const $3f411f3f8b100b70$var$diacritics = [
    {
        base: 'A',
        letters: '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'
    },
    {
        base: 'AA',
        letters: '\uA732'
    },
    {
        base: 'AE',
        letters: '\u00C6\u01FC\u01E2'
    },
    {
        base: 'AO',
        letters: '\uA734'
    },
    {
        base: 'AU',
        letters: '\uA736'
    },
    {
        base: 'AV',
        letters: '\uA738\uA73A'
    },
    {
        base: 'AY',
        letters: '\uA73C'
    },
    {
        base: 'B',
        letters: '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'
    },
    {
        base: 'C',
        letters: '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'
    },
    {
        base: 'D',
        letters: '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'
    },
    {
        base: 'DZ',
        letters: '\u01F1\u01C4'
    },
    {
        base: 'Dz',
        letters: '\u01F2\u01C5'
    },
    {
        base: 'E',
        letters: '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'
    },
    {
        base: 'F',
        letters: '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'
    },
    {
        base: 'G',
        letters: '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'
    },
    {
        base: 'H',
        letters: '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'
    },
    {
        base: 'I',
        letters: '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'
    },
    {
        base: 'J',
        letters: '\u004A\u24BF\uFF2A\u0134\u0248'
    },
    {
        base: 'K',
        letters: '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'
    },
    {
        base: 'L',
        letters: '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'
    },
    {
        base: 'LJ',
        letters: '\u01C7'
    },
    {
        base: 'Lj',
        letters: '\u01C8'
    },
    {
        base: 'M',
        letters: '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'
    },
    {
        base: 'N',
        letters: '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'
    },
    {
        base: 'NJ',
        letters: '\u01CA'
    },
    {
        base: 'Nj',
        letters: '\u01CB'
    },
    {
        base: 'O',
        letters: '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'
    },
    {
        base: 'OI',
        letters: '\u01A2'
    },
    {
        base: 'OO',
        letters: '\uA74E'
    },
    {
        base: 'OU',
        letters: '\u0222'
    },
    {
        base: 'P',
        letters: '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'
    },
    {
        base: 'Q',
        letters: '\u0051\u24C6\uFF31\uA756\uA758\u024A'
    },
    {
        base: 'R',
        letters: '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'
    },
    {
        base: 'S',
        letters: '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'
    },
    {
        base: 'T',
        letters: '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'
    },
    {
        base: 'TZ',
        letters: '\uA728'
    },
    {
        base: 'U',
        letters: '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'
    },
    {
        base: 'V',
        letters: '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'
    },
    {
        base: 'VY',
        letters: '\uA760'
    },
    {
        base: 'W',
        letters: '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'
    },
    {
        base: 'X',
        letters: '\u0058\u24CD\uFF38\u1E8A\u1E8C'
    },
    {
        base: 'Y',
        letters: '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'
    },
    {
        base: 'Z',
        letters: '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'
    },
    {
        base: 'a',
        letters: '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'
    },
    {
        base: 'aa',
        letters: '\uA733'
    },
    {
        base: 'ae',
        letters: '\u00E6\u01FD\u01E3'
    },
    {
        base: 'ao',
        letters: '\uA735'
    },
    {
        base: 'au',
        letters: '\uA737'
    },
    {
        base: 'av',
        letters: '\uA739\uA73B'
    },
    {
        base: 'ay',
        letters: '\uA73D'
    },
    {
        base: 'b',
        letters: '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'
    },
    {
        base: 'c',
        letters: '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'
    },
    {
        base: 'd',
        letters: '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'
    },
    {
        base: 'dz',
        letters: '\u01F3\u01C6'
    },
    {
        base: 'e',
        letters: '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'
    },
    {
        base: 'f',
        letters: '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'
    },
    {
        base: 'g',
        letters: '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'
    },
    {
        base: 'h',
        letters: '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'
    },
    {
        base: 'hv',
        letters: '\u0195'
    },
    {
        base: 'i',
        letters: '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'
    },
    {
        base: 'j',
        letters: '\u006A\u24D9\uFF4A\u0135\u01F0\u0249'
    },
    {
        base: 'k',
        letters: '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'
    },
    {
        base: 'l',
        letters: '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'
    },
    {
        base: 'lj',
        letters: '\u01C9'
    },
    {
        base: 'm',
        letters: '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'
    },
    {
        base: 'n',
        letters: '\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'
    },
    {
        base: 'nj',
        letters: '\u01CC'
    },
    {
        base: 'o',
        letters: '\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'
    },
    {
        base: 'oi',
        letters: '\u01A3'
    },
    {
        base: 'ou',
        letters: '\u0223'
    },
    {
        base: 'oo',
        letters: '\uA74F'
    },
    {
        base: 'p',
        letters: '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'
    },
    {
        base: 'q',
        letters: '\u0071\u24E0\uFF51\u024B\uA757\uA759'
    },
    {
        base: 'r',
        letters: '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'
    },
    {
        base: 's',
        letters: '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'
    },
    {
        base: 't',
        letters: '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'
    },
    {
        base: 'tz',
        letters: '\uA729'
    },
    {
        base: 'u',
        letters: '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'
    },
    {
        base: 'v',
        letters: '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'
    },
    {
        base: 'vy',
        letters: '\uA761'
    },
    {
        base: 'w',
        letters: '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'
    },
    {
        base: 'x',
        letters: '\u0078\u24E7\uFF58\u1E8B\u1E8D'
    },
    {
        base: 'y',
        letters: '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'
    },
    {
        base: 'z',
        letters: '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'
    }
];
const $3f411f3f8b100b70$var$anyDiacritic = new RegExp('[' + $3f411f3f8b100b70$var$diacritics.map((d)=>d.letters).join('') + ']', 'g');
const $3f411f3f8b100b70$var$diacriticToBase = {};
for(let i = 0; i < $3f411f3f8b100b70$var$diacritics.length; i++){
    let diacritic = $3f411f3f8b100b70$var$diacritics[i];
    for(let j = 0; j < diacritic.letters.length; j++)$3f411f3f8b100b70$var$diacriticToBase[diacritic.letters[j]] = diacritic.base;
}
const $3f411f3f8b100b70$export$b5bee4b27048330b = (str)=>{
    return str.replace($3f411f3f8b100b70$var$anyDiacritic, (match)=>$3f411f3f8b100b70$var$diacriticToBase[match]);
};


const $f921464ea1e07ecb$var$memoizedStripDiacriticsForInput = (0, $2XqLN.default)((0, $3f411f3f8b100b70$export$b5bee4b27048330b));
const $f921464ea1e07ecb$var$trimString = (str)=>str.replace(/^\s+|\s+$/g, '');
const $f921464ea1e07ecb$var$defaultStringify = (option)=>`${option.label} ${option.value}`;
const $f921464ea1e07ecb$export$5d81789ff4aeccdf = (config)=>(option, rawInput)=>{
        if (option.data.__isNew__) return true;
        const { ignoreCase: ignoreCase, ignoreAccents: ignoreAccents, stringify: stringify, trim: trim, matchFrom: matchFrom } = {
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $f921464ea1e07ecb$var$defaultStringify,
            trim: true,
            matchFrom: 'any',
            ...config
        };
        let input = trim ? $f921464ea1e07ecb$var$trimString(rawInput) : rawInput;
        let candidate = trim ? $f921464ea1e07ecb$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $f921464ea1e07ecb$var$memoizedStripDiacriticsForInput(input);
            candidate = (0, $3f411f3f8b100b70$export$b5bee4b27048330b)(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
module.exports["createFilter"] = $f921464ea1e07ecb$export$5d81789ff4aeccdf;

});

parcelRegister("eKXGE", function(module, exports) {

var $kM6CX = parcelRequire("kM6CX");


var $dLCCQ = parcelRequire("dLCCQ");


var $fPe0U = parcelRequire("fPe0U");


var $bX0kj = parcelRequire("bX0kj");


var $9gJAx = parcelRequire("9gJAx");


var $13TeD = parcelRequire("13TeD");


var $2ASIF = parcelRequire("2ASIF");


var $4K6SB = parcelRequire("4K6SB");


var $hsH3d = parcelRequire("hsH3d");


var $hf117 = parcelRequire("hf117");

const $6ab331f7326b3ca4$export$214b055320e0bf32 = {
    clearIndicator: (0, $bX0kj.clearIndicatorCSS),
    container: (0, $kM6CX.containerCSS),
    control: (0, $dLCCQ.css),
    dropdownIndicator: (0, $bX0kj.dropdownIndicatorCSS),
    group: (0, $fPe0U.groupCSS),
    groupHeading: (0, $fPe0U.groupHeadingCSS),
    indicatorsContainer: (0, $kM6CX.indicatorsContainerCSS),
    input: (0, $9gJAx.inputCSS),
    loadingIndicator: (0, $bX0kj.loadingIndicatorCSS),
    loadingMessage: (0, $13TeD.loadingMessageCSS),
    menu: (0, $13TeD.menuCSS),
    menuList: (0, $13TeD.menuListCSS),
    menuPortal: (0, $13TeD.menuPortalCSS),
    multiValue: (0, $2ASIF.multiValueCSS),
    multiValueLabel: (0, $2ASIF.multiValueLabelCSS),
    multiValueRemove: (0, $2ASIF.multiValueRemoveCSS),
    noOptionsMessage: (0, $13TeD.noOptionsMessageCSS),
    option: (0, $4K6SB.optionCSS),
    placeholder: (0, $hsH3d.placeholderCSS),
    singleValue: (0, $hf117.css),
    valueContainer: (0, $kM6CX.valueContainerCSS)
};
function $6ab331f7326b3ca4$export$e618dc39ac9ad607(source, target = {}) {
    // initialize with source styles
    const styles = {
        ...source
    };
    // massage in target styles
    Object.keys(target).forEach((keyAsString)=>{
        const key = keyAsString;
        if (source[key]) styles[key] = (rsCss, props)=>{
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
module.exports["defaultStyles"] = $6ab331f7326b3ca4$export$214b055320e0bf32;
module.exports["mergeStyles"] = $6ab331f7326b3ca4$export$e618dc39ac9ad607;

});

parcelRegister("gJgOY", function(module, exports) {
$parcel$export(module.exports, "default", () => $3ff5e862515f2388$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $A6wna = parcelRequire("A6wna");

function $3ff5e862515f2388$export$2e2bcd8739ae039({ defaultOptions: propsDefaultOptions = false, cacheOptions: cacheOptions = false, loadOptions: propsLoadOptions, options: propsOptions, isLoading: propsIsLoading = false, onInputChange: propsOnInputChange, filterOption: filterOption = null, ...restSelectProps }) {
    const { inputValue: propsInputValue } = restSelectProps;
    const lastRequest = (0, $42omo.useRef)(undefined);
    const mounted = (0, $42omo.useRef)(false);
    const [defaultOptions, setDefaultOptions] = (0, $42omo.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
    const [stateInputValue, setStateInputValue] = (0, $42omo.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : '');
    const [isLoading, setIsLoading] = (0, $42omo.useState)(propsDefaultOptions === true);
    const [loadedInputValue, setLoadedInputValue] = (0, $42omo.useState)(undefined);
    const [loadedOptions, setLoadedOptions] = (0, $42omo.useState)([]);
    const [passEmptyOptions, setPassEmptyOptions] = (0, $42omo.useState)(false);
    const [optionsCache, setOptionsCache] = (0, $42omo.useState)({});
    const [prevDefaultOptions, setPrevDefaultOptions] = (0, $42omo.useState)(undefined);
    const [prevCacheOptions, setPrevCacheOptions] = (0, $42omo.useState)(undefined);
    if (cacheOptions !== prevCacheOptions) {
        setOptionsCache({});
        setPrevCacheOptions(cacheOptions);
    }
    if (propsDefaultOptions !== prevDefaultOptions) {
        setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        setPrevDefaultOptions(propsDefaultOptions);
    }
    (0, $42omo.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    const loadOptions = (0, $42omo.useCallback)((inputValue, callback)=>{
        if (!propsLoadOptions) return callback();
        const loader = propsLoadOptions(inputValue, callback);
        if (loader && typeof loader.then === 'function') loader.then(callback, ()=>callback());
    }, [
        propsLoadOptions
    ]);
    (0, $42omo.useEffect)(()=>{
        if (propsDefaultOptions === true) loadOptions(stateInputValue, (options)=>{
            if (!mounted.current) return;
            setDefaultOptions(options || []);
            setIsLoading(!!lastRequest.current);
        });
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onInputChange = (0, $42omo.useCallback)((newValue, actionMeta)=>{
        const inputValue = (0, $A6wna.handleInputChange)(newValue, actionMeta, propsOnInputChange);
        if (!inputValue) {
            lastRequest.current = undefined;
            setStateInputValue('');
            setLoadedInputValue('');
            setLoadedOptions([]);
            setIsLoading(false);
            setPassEmptyOptions(false);
            return;
        }
        if (cacheOptions && optionsCache[inputValue]) {
            setStateInputValue(inputValue);
            setLoadedInputValue(inputValue);
            setLoadedOptions(optionsCache[inputValue]);
            setIsLoading(false);
            setPassEmptyOptions(false);
        } else {
            const request = lastRequest.current = {};
            setStateInputValue(inputValue);
            setIsLoading(true);
            setPassEmptyOptions(!loadedInputValue);
            loadOptions(inputValue, (options)=>{
                if (!mounted) return;
                if (request !== lastRequest.current) return;
                lastRequest.current = undefined;
                setIsLoading(false);
                setLoadedInputValue(inputValue);
                setLoadedOptions(options || []);
                setPassEmptyOptions(false);
                setOptionsCache(options ? {
                    ...optionsCache,
                    [inputValue]: options
                } : optionsCache);
            });
        }
    }, [
        cacheOptions,
        loadOptions,
        loadedInputValue,
        optionsCache,
        propsOnInputChange
    ]);
    const options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
    return {
        ...restSelectProps,
        options: options,
        isLoading: isLoading || propsIsLoading,
        onInputChange: onInputChange,
        filterOption: filterOption
    };
}

});

parcelRegister("kjDWr", function(module, exports) {
$parcel$export(module.exports, "default", () => $ec570eb86c5ed061$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $ec570eb86c5ed061$export$2e2bcd8739ae039({ defaultInputValue: defaultInputValue = '', defaultMenuIsOpen: defaultMenuIsOpen = false, defaultValue: defaultValue = null, inputValue: propsInputValue, menuIsOpen: propsMenuIsOpen, onChange: propsOnChange, onInputChange: propsOnInputChange, onMenuClose: propsOnMenuClose, onMenuOpen: propsOnMenuOpen, value: propsValue, ...restSelectProps }) {
    const [stateInputValue, setStateInputValue] = (0, $42omo.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue);
    const [stateMenuIsOpen, setStateMenuIsOpen] = (0, $42omo.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen);
    const [stateValue, setStateValue] = (0, $42omo.useState)(propsValue !== undefined ? propsValue : defaultValue);
    const onChange = (0, $42omo.useCallback)((value, actionMeta)=>{
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    const onInputChange = (0, $42omo.useCallback)((value, actionMeta)=>{
        let newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    const onMenuOpen = (0, $42omo.useCallback)(()=>{
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    const onMenuClose = (0, $42omo.useCallback)(()=>{
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    const inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    const menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    const value = propsValue !== undefined ? propsValue : stateValue;
    //@ts-ignore react-select unsupported props
    return {
        ...restSelectProps,
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    };
}

});

parcelRegister("hQK6j", function(module, exports) {
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $cfeb0daed3e4ff22$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $cfeb0daed3e4ff22$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $cfeb0daed3e4ff22$export$803cd8101b6c182b = /*#__PURE__*/ $cfeb0daed3e4ff22$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $cfeb0daed3e4ff22$export$27b07d8a310ed8b5[0], side + "-" + $cfeb0daed3e4ff22$export$27b07d8a310ed8b5[1]), []);
const $cfeb0daed3e4ff22$export$96ec731ed4dcb222 = Math.min;
const $cfeb0daed3e4ff22$export$8960430cfd85939f = Math.max;
const $cfeb0daed3e4ff22$export$2077e0241d6afd3c = Math.round;
const $cfeb0daed3e4ff22$export$a3fe094919f356fd = Math.floor;
const $cfeb0daed3e4ff22$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $cfeb0daed3e4ff22$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
const $cfeb0daed3e4ff22$var$oppositeAlignmentMap = {
    start: 'end',
    end: 'start'
};
function $cfeb0daed3e4ff22$export$7d15b64cf5a3a4c4(start, value, end) {
    return $cfeb0daed3e4ff22$export$8960430cfd85939f(start, $cfeb0daed3e4ff22$export$96ec731ed4dcb222(value, end));
}
function $cfeb0daed3e4ff22$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $cfeb0daed3e4ff22$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $cfeb0daed3e4ff22$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $cfeb0daed3e4ff22$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $cfeb0daed3e4ff22$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
const $cfeb0daed3e4ff22$var$yAxisSides = /*#__PURE__*/ new Set([
    'top',
    'bottom'
]);
function $cfeb0daed3e4ff22$export$f28e8f882010718a(placement) {
    return $cfeb0daed3e4ff22$var$yAxisSides.has($cfeb0daed3e4ff22$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
}
function $cfeb0daed3e4ff22$export$2b57e0052a6d6d4c(placement) {
    return $cfeb0daed3e4ff22$export$8a000a963141ac32($cfeb0daed3e4ff22$export$f28e8f882010718a(placement));
}
function $cfeb0daed3e4ff22$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $cfeb0daed3e4ff22$export$f0989780f32bfcda(placement);
    const alignmentAxis = $cfeb0daed3e4ff22$export$2b57e0052a6d6d4c(placement);
    const length = $cfeb0daed3e4ff22$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $cfeb0daed3e4ff22$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $cfeb0daed3e4ff22$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $cfeb0daed3e4ff22$export$496432a3699e50b1(placement) {
    const oppositePlacement = $cfeb0daed3e4ff22$export$9c5e28bad23365fa(placement);
    return [
        $cfeb0daed3e4ff22$export$2b182c584985588b(placement),
        oppositePlacement,
        $cfeb0daed3e4ff22$export$2b182c584985588b(oppositePlacement)
    ];
}
function $cfeb0daed3e4ff22$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$cfeb0daed3e4ff22$var$oppositeAlignmentMap[alignment]);
}
const $cfeb0daed3e4ff22$var$lrPlacement = [
    'left',
    'right'
];
const $cfeb0daed3e4ff22$var$rlPlacement = [
    'right',
    'left'
];
const $cfeb0daed3e4ff22$var$tbPlacement = [
    'top',
    'bottom'
];
const $cfeb0daed3e4ff22$var$btPlacement = [
    'bottom',
    'top'
];
function $cfeb0daed3e4ff22$var$getSideList(side, isStart, rtl) {
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? $cfeb0daed3e4ff22$var$rlPlacement : $cfeb0daed3e4ff22$var$lrPlacement;
            return isStart ? $cfeb0daed3e4ff22$var$lrPlacement : $cfeb0daed3e4ff22$var$rlPlacement;
        case 'left':
        case 'right':
            return isStart ? $cfeb0daed3e4ff22$var$tbPlacement : $cfeb0daed3e4ff22$var$btPlacement;
        default:
            return [];
    }
}
function $cfeb0daed3e4ff22$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $cfeb0daed3e4ff22$export$f0989780f32bfcda(placement);
    let list = $cfeb0daed3e4ff22$var$getSideList($cfeb0daed3e4ff22$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($cfeb0daed3e4ff22$export$2b182c584985588b));
    }
    return list;
}
function $cfeb0daed3e4ff22$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$cfeb0daed3e4ff22$var$oppositeSideMap[side]);
}
function $cfeb0daed3e4ff22$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $cfeb0daed3e4ff22$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $cfeb0daed3e4ff22$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $cfeb0daed3e4ff22$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}
module.exports["sides"] = $cfeb0daed3e4ff22$export$832b6fa47fa053d2;
module.exports["placements"] = $cfeb0daed3e4ff22$export$803cd8101b6c182b;
module.exports["min"] = $cfeb0daed3e4ff22$export$96ec731ed4dcb222;
module.exports["max"] = $cfeb0daed3e4ff22$export$8960430cfd85939f;
module.exports["round"] = $cfeb0daed3e4ff22$export$2077e0241d6afd3c;
module.exports["floor"] = $cfeb0daed3e4ff22$export$a3fe094919f356fd;
module.exports["createCoords"] = $cfeb0daed3e4ff22$export$a397704b5e280835;
module.exports["clamp"] = $cfeb0daed3e4ff22$export$7d15b64cf5a3a4c4;
module.exports["evaluate"] = $cfeb0daed3e4ff22$export$fef61f332f2c0afc;
module.exports["getSide"] = $cfeb0daed3e4ff22$export$3c915306cb7fc97a;
module.exports["getAlignment"] = $cfeb0daed3e4ff22$export$f0989780f32bfcda;
module.exports["getOppositeAxis"] = $cfeb0daed3e4ff22$export$8a000a963141ac32;
module.exports["getAxisLength"] = $cfeb0daed3e4ff22$export$320bd9d53520c68a;
module.exports["getSideAxis"] = $cfeb0daed3e4ff22$export$f28e8f882010718a;
module.exports["getAlignmentAxis"] = $cfeb0daed3e4ff22$export$2b57e0052a6d6d4c;
module.exports["getAlignmentSides"] = $cfeb0daed3e4ff22$export$be42861551f17911;
module.exports["getOppositePlacement"] = $cfeb0daed3e4ff22$export$9c5e28bad23365fa;
module.exports["getExpandedPlacements"] = $cfeb0daed3e4ff22$export$496432a3699e50b1;
module.exports["getOppositeAlignmentPlacement"] = $cfeb0daed3e4ff22$export$2b182c584985588b;
module.exports["getOppositeAxisPlacements"] = $cfeb0daed3e4ff22$export$a9b6fb18fd92c3ec;
module.exports["getPaddingObject"] = $cfeb0daed3e4ff22$export$598c291c29bc2e71;
module.exports["rectToClientRect"] = $cfeb0daed3e4ff22$export$ee05aea0aeecbad4;

});

parcelRegister("43qiz", function(module, exports) {
function $2f3bd792fcf23e5d$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $2f3bd792fcf23e5d$export$651544f548703224(node) {
    if ($2f3bd792fcf23e5d$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $2f3bd792fcf23e5d$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $2f3bd792fcf23e5d$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($2f3bd792fcf23e5d$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $2f3bd792fcf23e5d$export$8ee0fc9ee280b4ee(value) {
    if (!$2f3bd792fcf23e5d$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $2f3bd792fcf23e5d$export$38b2d434cce3ea22(value).Node;
}
function $2f3bd792fcf23e5d$export$45a5e7f76e0caa8d(value) {
    if (!$2f3bd792fcf23e5d$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $2f3bd792fcf23e5d$export$38b2d434cce3ea22(value).Element;
}
function $2f3bd792fcf23e5d$export$1b3bfaa9684536aa(value) {
    if (!$2f3bd792fcf23e5d$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $2f3bd792fcf23e5d$export$38b2d434cce3ea22(value).HTMLElement;
}
function $2f3bd792fcf23e5d$export$af51f0f06c0f328a(value) {
    if (!$2f3bd792fcf23e5d$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $2f3bd792fcf23e5d$export$38b2d434cce3ea22(value).ShadowRoot;
}
const $2f3bd792fcf23e5d$var$invalidOverflowDisplayValues = /*#__PURE__*/ new Set([
    'inline',
    'contents'
]);
function $2f3bd792fcf23e5d$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $2f3bd792fcf23e5d$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !$2f3bd792fcf23e5d$var$invalidOverflowDisplayValues.has(display);
}
const $2f3bd792fcf23e5d$var$tableElements = /*#__PURE__*/ new Set([
    'table',
    'td',
    'th'
]);
function $2f3bd792fcf23e5d$export$71535ffaa902797f(element) {
    return $2f3bd792fcf23e5d$var$tableElements.has($2f3bd792fcf23e5d$export$651544f548703224(element));
}
const $2f3bd792fcf23e5d$var$topLayerSelectors = [
    ':popover-open',
    ':modal'
];
function $2f3bd792fcf23e5d$export$89e651af02346cd4(element) {
    return $2f3bd792fcf23e5d$var$topLayerSelectors.some((selector)=>{
        try {
            return element.matches(selector);
        } catch (_e) {
            return false;
        }
    });
}
const $2f3bd792fcf23e5d$var$transformProperties = [
    'transform',
    'translate',
    'scale',
    'rotate',
    'perspective'
];
const $2f3bd792fcf23e5d$var$willChangeValues = [
    'transform',
    'translate',
    'scale',
    'rotate',
    'perspective',
    'filter'
];
const $2f3bd792fcf23e5d$var$containValues = [
    'paint',
    'layout',
    'strict',
    'content'
];
function $2f3bd792fcf23e5d$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $2f3bd792fcf23e5d$export$78551043582a6a98();
    const css = $2f3bd792fcf23e5d$export$45a5e7f76e0caa8d(elementOrCss) ? $2f3bd792fcf23e5d$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return $2f3bd792fcf23e5d$var$transformProperties.some((value)=>css[value] ? css[value] !== 'none' : false) || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || $2f3bd792fcf23e5d$var$willChangeValues.some((value)=>(css.willChange || '').includes(value)) || $2f3bd792fcf23e5d$var$containValues.some((value)=>(css.contain || '').includes(value));
}
function $2f3bd792fcf23e5d$export$940d8225183e1404(element) {
    let currentNode = $2f3bd792fcf23e5d$export$4e12058fc4d51d56(element);
    while($2f3bd792fcf23e5d$export$1b3bfaa9684536aa(currentNode) && !$2f3bd792fcf23e5d$export$d1162fb0b6d4cd51(currentNode)){
        if ($2f3bd792fcf23e5d$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($2f3bd792fcf23e5d$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $2f3bd792fcf23e5d$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $2f3bd792fcf23e5d$export$78551043582a6a98() {
    if (typeof CSS === 'undefined' || !CSS.supports) return false;
    return CSS.supports('-webkit-backdrop-filter', 'none');
}
const $2f3bd792fcf23e5d$var$lastTraversableNodeNames = /*#__PURE__*/ new Set([
    'html',
    'body',
    '#document'
]);
function $2f3bd792fcf23e5d$export$d1162fb0b6d4cd51(node) {
    return $2f3bd792fcf23e5d$var$lastTraversableNodeNames.has($2f3bd792fcf23e5d$export$651544f548703224(node));
}
function $2f3bd792fcf23e5d$export$3735103072e4a80(element) {
    return $2f3bd792fcf23e5d$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $2f3bd792fcf23e5d$export$dc8fc79fa2800137(element) {
    if ($2f3bd792fcf23e5d$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $2f3bd792fcf23e5d$export$4e12058fc4d51d56(node) {
    if ($2f3bd792fcf23e5d$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $2f3bd792fcf23e5d$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $2f3bd792fcf23e5d$export$e495491855dc5418(node);
    return $2f3bd792fcf23e5d$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $2f3bd792fcf23e5d$export$7cd01a57c8ca906c(node) {
    const parentNode = $2f3bd792fcf23e5d$export$4e12058fc4d51d56(node);
    if ($2f3bd792fcf23e5d$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($2f3bd792fcf23e5d$export$1b3bfaa9684536aa(parentNode) && $2f3bd792fcf23e5d$export$989e911fa9af580a(parentNode)) return parentNode;
    return $2f3bd792fcf23e5d$export$7cd01a57c8ca906c(parentNode);
}
function $2f3bd792fcf23e5d$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $2f3bd792fcf23e5d$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $2f3bd792fcf23e5d$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $2f3bd792fcf23e5d$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $2f3bd792fcf23e5d$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $2f3bd792fcf23e5d$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $2f3bd792fcf23e5d$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $2f3bd792fcf23e5d$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}
module.exports["getNodeName"] = $2f3bd792fcf23e5d$export$651544f548703224;
module.exports["getWindow"] = $2f3bd792fcf23e5d$export$38b2d434cce3ea22;
module.exports["getDocumentElement"] = $2f3bd792fcf23e5d$export$e495491855dc5418;
module.exports["isElement"] = $2f3bd792fcf23e5d$export$45a5e7f76e0caa8d;
module.exports["isHTMLElement"] = $2f3bd792fcf23e5d$export$1b3bfaa9684536aa;
module.exports["isOverflowElement"] = $2f3bd792fcf23e5d$export$989e911fa9af580a;
module.exports["getComputedStyle"] = $2f3bd792fcf23e5d$export$3735103072e4a80;
module.exports["isTableElement"] = $2f3bd792fcf23e5d$export$71535ffaa902797f;
module.exports["isTopLayer"] = $2f3bd792fcf23e5d$export$89e651af02346cd4;
module.exports["isContainingBlock"] = $2f3bd792fcf23e5d$export$d6c4e8150c35fed1;
module.exports["isWebKit"] = $2f3bd792fcf23e5d$export$78551043582a6a98;
module.exports["getContainingBlock"] = $2f3bd792fcf23e5d$export$940d8225183e1404;
module.exports["getParentNode"] = $2f3bd792fcf23e5d$export$4e12058fc4d51d56;
module.exports["isLastTraversableNode"] = $2f3bd792fcf23e5d$export$d1162fb0b6d4cd51;
module.exports["getNodeScroll"] = $2f3bd792fcf23e5d$export$dc8fc79fa2800137;
module.exports["getOverflowAncestors"] = $2f3bd792fcf23e5d$export$3b57c1601291186b;
module.exports["getFrameElement"] = $2f3bd792fcf23e5d$export$7bf1f8740e3e34af;

});

parcelRegister("13TeD", function(module, exports) {
/* menu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1bHXt = parcelRequire("1bHXt");


var $lGw97 = parcelRequire("lGw97");


var $jTxSS = parcelRequire("jTxSS");


var $i0iqW = parcelRequire("i0iqW");


var $dh538 = parcelRequire("dh538");


var $iXCQx = parcelRequire("iXCQx");


var $A6wna = parcelRequire("A6wna");

function $592398492de9d999$var$getMenuPlacement({ maxHeight: preferredMaxHeight, menuEl: menuEl, minHeight: minHeight, placement: preferredPlacement, shouldScroll: shouldScroll, isFixedPosition: isFixedPosition, controlHeight: controlHeight }) {
    const scrollParent = (0, $A6wna.getScrollParent)(menuEl);
    const defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    }; // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
     // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    const { height: scrollHeight } = scrollParent.getBoundingClientRect();
    const { bottom: menuBottom, height: menuHeight, top: menuTop } = menuEl.getBoundingClientRect();
    const { top: containerTop } = menuEl.offsetParent.getBoundingClientRect();
    const viewHeight = isFixedPosition ? window.innerHeight : (0, $A6wna.normalizedHeight)(scrollParent);
    const scrollTop = (0, $A6wna.getScrollTop)(scrollParent);
    const menuTopFromParent = menuTop;
    const marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    const marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    const viewSpaceAbove = containerTop - marginTop;
    const viewSpaceBelow = viewHeight - menuTopFromParent;
    const scrollSpaceAbove = viewSpaceAbove + scrollTop;
    const scrollSpaceBelow = scrollHeight - scrollTop - menuTopFromParent;
    const scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    const scrollUp = scrollTop + menuTop - marginTop;
    const scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
             // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $A6wna.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            } // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) (0, $A6wna.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                 // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                const constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            } // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                let constrainedHeight = preferredMaxHeight;
                const spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            } // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) (0, $A6wna.scrollTo)(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
             // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $A6wna.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            } // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                let constrainedHeight = preferredMaxHeight; // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) constrainedHeight = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) (0, $A6wna.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            } // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error(`Invalid placement provided "${preferredPlacement}".`);
    }
    return defaultState;
}
const $592398492de9d999$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
const $592398492de9d999$var$menuStyles = {
    root: "_2rko12b0 _kqswstnw _1bsb1osq _1pbykb7n _6rthu2gc _1pfhu2gc _bfhk1bhr _16qs130s",
    rootT26Shape: "_2rko1mok",
    bottom: "_152t1osq",
    top: "_u7co1osq"
};
const $592398492de9d999$export$a228922d5ca42a79 = ()=>({});
const $592398492de9d999$var$PortalPlacementContext = /*#__PURE__*/ (0, $42omo.createContext)(null); // NOTE: internal only
const $592398492de9d999$export$f32337f3a7617699 = (props)=>{
    const { children: children, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView } = props;
    const { setPortalPlacement: setPortalPlacement } = (0, $42omo.useContext)($592398492de9d999$var$PortalPlacementContext) || {};
    const ref = (0, $42omo.useRef)(null);
    const [maxHeight, setMaxHeight] = (0, $42omo.useState)(maxMenuHeight);
    const [placement, setPlacement] = (0, $42omo.useState)(null); // The minimum height of the control
    const controlHeight = 38;
    (0, $i0iqW.default)(()=>{
        const menuEl = ref.current;
        if (!menuEl) return;
         // DO NOT scroll if position is fixed
        const isFixedPosition = menuPosition === 'fixed';
        const shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        const state = $592398492de9d999$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement?.(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: {
            ...props,
            placement: placement || $592398492de9d999$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        }
    });
};
const $592398492de9d999$var$Menu = (props)=>{
    const { children: children, innerRef: innerRef, innerProps: innerProps, placement: placement = 'bottom', xcss: xcss } = props;
    const { css: css, className: className } = (0, $A6wna.getStyleProps)(props, 'menu', {
        menu: true
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
    , {
        className: (0, $gMc0m.default)([
            $592398492de9d999$var$menuStyles.root,
            $592398492de9d999$var$menuStyles[placement],
            (0, $dh538.fg)('platform-dst-shape-theme-default') && $592398492de9d999$var$menuStyles.rootT26Shape,
            (0, $1bHXt.cx)(xcss, className, '-menu')
        ]),
        style: css,
        ref: innerRef,
        ...innerProps,
        children: children
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $592398492de9d999$export$2e2bcd8739ae039 // ==============================
 = $592398492de9d999$var$Menu;
const $592398492de9d999$export$abafed69cff95d5e = ()=>({});
const $592398492de9d999$var$menuListStyles = null; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $592398492de9d999$export$d4c4e98c5044dc8 = (props)=>{
    const { children: children, innerProps: innerProps, innerRef: innerRef, isMulti: isMulti, maxHeight: maxHeight, xcss: xcss } = props;
    const { css: css, className: className } = (0, $A6wna.getStyleProps)(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
    , {
        className: (0, $gMc0m.default)([
            "_kqswh2mm _18m91wug _85i5u2gc _1q51u2gc _8am5i4x0",
            (0, $1bHXt.cx)(className, xcss, '-MenuList')
        ]),
        style: {
            ...css,
            maxHeight: maxHeight
        },
        ref: innerRef,
        ...innerProps,
        tabIndex: -1,
        children: children
    });
}; // ==============================
// Menu Notices
// ==============================
const $592398492de9d999$var$noticeCSS = ()=>({});
const $592398492de9d999$var$noticeStyles = null;
const $592398492de9d999$export$cf0e22534d8b0074 = $592398492de9d999$var$noticeCSS;
const $592398492de9d999$export$98ec46397a8cb3cd = $592398492de9d999$var$noticeCSS;
const $592398492de9d999$export$d58b72b7d3c4072c = ({ children: children = 'No options', innerProps: innerProps, xcss: xcss, ...restProps })=>{
    const { css: css, className: className } = (0, $A6wna.getStyleProps)({
        ...restProps,
        children: children,
        innerProps: innerProps
    }, 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
    , {
        className: (0, $gMc0m.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $1bHXt.cx)(className, xcss, '-NoOptionsMessage')
        ]),
        style: css,
        role: "option",
        ...innerProps,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
            color: "color.text.subtle",
            children: children
        })
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $592398492de9d999$export$e928a71d039d3102 = ({ children: children = 'Loading...', innerProps: innerProps, xcss: xcss, ...restProps })=>{
    const { css: css, className: className } = (0, $A6wna.getStyleProps)({
        ...restProps,
        children: children,
        innerProps: innerProps
    }, 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
    , {
        className: (0, $gMc0m.default)([
            "_85i5u2gc _1q51u2gc _y4tiutpp _bozgutpp _y3gn1h6o",
            (0, $1bHXt.cx)(className, xcss, '-LoadingMessage')
        ]),
        style: css,
        ...innerProps,
        role: "option",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
            color: "color.text.subtle",
            children: children
        })
    });
}; // ==============================
const $592398492de9d999$export$1dbbeb9648d1fdc9 = ()=>({});
const $592398492de9d999$var$menuPortalStyles = {
    root: "_1pbykb7n _1e02a1vk _kqswcp1v _152t1nmo _1bsb1qxj"
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $592398492de9d999$export$793392f970497feb = (props)=>{
    const { appendTo: appendTo, children: children, controlElement: controlElement, innerProps: innerProps, menuPlacement: menuPlacement, menuPosition: menuPosition, xcss: xcss } = props;
    const menuPortalRef = (0, $42omo.useRef)(null);
    const cleanupRef = (0, $42omo.useRef)(null);
    const [placement, setPortalPlacement] = (0, $42omo.useState)($592398492de9d999$var$coercePlacement(menuPlacement));
    const portalPlacementContext = (0, $42omo.useMemo)(()=>({
            setPortalPlacement: setPortalPlacement
        }), []);
    const [computedPosition, setComputedPosition] = (0, $42omo.useState)(null);
    const updateComputedPosition = (0, $42omo.useCallback)(()=>{
        if (!controlElement) return;
        const rect = (0, $A6wna.getBoundingClientObj)(controlElement);
        const scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        const offset = rect[placement] + scrollDistance;
        if (offset !== computedPosition?.offset || rect.left !== computedPosition?.rect.left || rect.width !== computedPosition?.rect.width) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition?.offset,
        computedPosition?.rect.left,
        computedPosition?.rect.width
    ]);
    (0, $i0iqW.default)(()=>{
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    const runAutoUpdate = (0, $42omo.useCallback)(()=>{
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $lGw97.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $i0iqW.default)(()=>{
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    const setMenuPortalElement = (0, $42omo.useCallback)((menuPortalElement)=>{
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]); // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    const { css: css, className: className } = (0, $A6wna.getStyleProps)({
        ...props,
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }, 'menuPortal', {
        'menu-portal': true
    }); // same wrapper element whether fixed or portalled
    const menuWrapper = /*#__PURE__*/ (0, $l998X.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
    , {
        className: (0, $gMc0m.default)([
            $592398492de9d999$var$menuPortalStyles.root,
            (0, $1bHXt.cx)(className, xcss, '-MenuPortal')
        ]),
        ref: setMenuPortalElement,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            '--menu-left': `${computedPosition.rect.left}px`,
            '--menu-position': menuPosition,
            '--menu-top': `${computedPosition.offset}px`,
            '--menu-width': `${computedPosition.rect.width}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...css
        },
        ...innerProps,
        children: children
    });
    return /*#__PURE__*/ (0, $l998X.jsx)($592398492de9d999$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext,
        children: appendTo ? /*#__PURE__*/ (0, $jTxSS.createPortal)(menuWrapper, appendTo) : menuWrapper
    });
};
module.exports["menuCSS"] = $592398492de9d999$export$a228922d5ca42a79;
module.exports["MenuPlacer"] = $592398492de9d999$export$f32337f3a7617699;
module.exports["default"] = $592398492de9d999$export$2e2bcd8739ae039;
module.exports["menuListCSS"] = $592398492de9d999$export$abafed69cff95d5e;
module.exports["MenuList"] = $592398492de9d999$export$d4c4e98c5044dc8;
module.exports["noOptionsMessageCSS"] = $592398492de9d999$export$cf0e22534d8b0074;
module.exports["loadingMessageCSS"] = $592398492de9d999$export$98ec46397a8cb3cd;
module.exports["NoOptionsMessage"] = $592398492de9d999$export$d58b72b7d3c4072c;
module.exports["LoadingMessage"] = $592398492de9d999$export$e928a71d039d3102;
module.exports["menuPortalCSS"] = $592398492de9d999$export$1dbbeb9648d1fdc9;
module.exports["MenuPortal"] = $592398492de9d999$export$793392f970497feb;

});

parcelRegister("kM6CX", function(module, exports) {
/* containers.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1bHXt = parcelRequire("1bHXt");


var $A6wna = parcelRequire("A6wna");

const $e2d30bad9e484062$export$949392aeaf7d2e3a = ()=>({});
const $e2d30bad9e484062$var$containerStyles = {
    default: "_11c81d4k _kqswh2mm _lcxv1rj4 _1tn2fhey",
    rtl: "_1eim1xrj",
    disabled: "_80om13gf"
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $e2d30bad9e484062$export$446eebadefe1123b = (props)=>{
    const { children: children, innerProps: innerProps, isDisabled: isDisabled, isRtl: isRtl, xcss: xcss } = props;
    const { className: className, css: css } = (0, $A6wna.getStyleProps)(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
    , {
        className: (0, $gMc0m.default)([
            $e2d30bad9e484062$var$containerStyles.default,
            isRtl && $e2d30bad9e484062$var$containerStyles.rtl,
            isDisabled && $e2d30bad9e484062$var$containerStyles.disabled,
            (0, $1bHXt.cx)(className, xcss, '-container')
        ]),
        style: css,
        ...innerProps,
        children: children
    });
};
const $e2d30bad9e484062$export$47aec73c7aa6b9aa = ()=>({});
const $e2d30bad9e484062$var$valueContainerStyles = {
    default: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _4cvr1h6o _1e0c11p5 _1n261g80 _8am5i4x0 _kqswh2mm _ca0qv77o _u5f312x7 _n3tdv77o _19bv12x7",
    flex: "_1e0c1txw",
    compact: "_ca0qze3t _u5f312x7 _n3tdze3t _19bv12x7"
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $e2d30bad9e484062$export$4dc9f58ad9a1a000 = (props)=>{
    const { children: children, innerProps: innerProps, isMulti: isMulti, hasValue: hasValue, isCompact: isCompact, xcss: xcss, selectProps: { controlShouldRenderValue: controlShouldRenderValue } } = props;
    const { css: css, className: className } = (0, $A6wna.getStyleProps)(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
    , {
        className: (0, $gMc0m.default)([
            $e2d30bad9e484062$var$valueContainerStyles.default,
            isMulti && hasValue && controlShouldRenderValue && $e2d30bad9e484062$var$valueContainerStyles.flex,
            isCompact && $e2d30bad9e484062$var$valueContainerStyles.compact,
            (0, $1bHXt.cx)(className, xcss, '-ValueContainer')
        ]),
        style: css,
        ...innerProps,
        children: children
    });
}; // ==============================
const $e2d30bad9e484062$export$9d74e3c8b5868ad7 = ()=>({});
const $e2d30bad9e484062$var$indicatorContainerStyles = null; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $e2d30bad9e484062$export$d0ffd7e649cab6f = (props)=>{
    const { children: children, innerProps: innerProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $A6wna.getStyleProps)(props, 'indicatorsContainer', {
        indicators: true
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: css,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o _1o9zidpf _1wpz1fhb _y4ti1b66",
            (0, $1bHXt.cx)(className, xcss, '-IndicatorsContainer')
        ]),
        ...innerProps,
        children: children
    });
};
module.exports["containerCSS"] = $e2d30bad9e484062$export$949392aeaf7d2e3a;
module.exports["SelectContainer"] = $e2d30bad9e484062$export$446eebadefe1123b;
module.exports["valueContainerCSS"] = $e2d30bad9e484062$export$47aec73c7aa6b9aa;
module.exports["ValueContainer"] = $e2d30bad9e484062$export$4dc9f58ad9a1a000;
module.exports["indicatorsContainerCSS"] = $e2d30bad9e484062$export$9d74e3c8b5868ad7;
module.exports["IndicatorsContainer"] = $e2d30bad9e484062$export$d0ffd7e649cab6f;

});

parcelRegister("dLCCQ", function(module, exports) {
/* control.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1bHXt = parcelRequire("1bHXt");


var $dh538 = parcelRequire("dh538");


var $A6wna = parcelRequire("A6wna");

const $c7cbf49b89c34667$var$styles = {
    default: "_12ji1r31 _1qu2glyw _12y3idpf _2rkofajl _v564r5cv _1h6drsbi _1dqonqa1 _189ee4h9 _4cvr1h6o _80om73ad _1e0c1txw _1n261g80 _1bah1yb4 _kqswh2mm _bfhk1j9a _1tke1ylp _1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _15peftgi _1ke8ftgi _jaboglyw _1u6luvb6 _4cvxrsbi _123byq51 _d0altlke _irr3l4ek _1ogl1caj",
    defaultT26Shape: "_2rko1qi0",
    compact: "_1tkezwfg",
    invalid: "_1h6d1bqt _16qsizbr _1u6lizbr _4cvx1bqt",
    focusedInvalid: "_16qsvyy1",
    disabled: "_1h6dby5v _lcxvglyw _bfhkby5v _1u6l1s3b",
    focused: "_1h6d1v1w _bfhkr01l _16qsvyy1 _1u6lvyy1 _4cvx1v1w _irr3r01l",
    subtle: "_1h6d1j28 _bfhk1j28 _1u6l3sij",
    subtleFocused: "_bfhkvuon",
    none: "_1h6d1j28 _bfhk1j28 _1u6l3sij _4cvx1j28 _irr31j28"
};
const $c7cbf49b89c34667$export$dbf350e5966cf602 = ()=>({});
const $c7cbf49b89c34667$var$Control = (props)=>{
    const { children: children, appearance: appearance, isCompact: isCompact, isDisabled: isDisabled, isFocused: isFocused, isInvalid: isInvalid, innerRef: innerRef, innerProps: innerProps, menuIsOpen: menuIsOpen, xcss: xcss } = props;
    const { css: css, className: className } = (0, $A6wna.getStyleProps)(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        ref: innerRef,
        className: (0, $gMc0m.default)([
            $c7cbf49b89c34667$var$styles.default,
            (0, $dh538.fg)('platform-dst-shape-theme-default') && $c7cbf49b89c34667$var$styles.defaultT26Shape,
            isDisabled && $c7cbf49b89c34667$var$styles.disabled,
            isInvalid && $c7cbf49b89c34667$var$styles.invalid,
            isCompact && $c7cbf49b89c34667$var$styles.compact,
            appearance === 'subtle' && $c7cbf49b89c34667$var$styles.subtle,
            appearance === 'subtle' && isFocused && $c7cbf49b89c34667$var$styles.subtleFocused,
            isFocused && $c7cbf49b89c34667$var$styles.focused,
            appearance === 'none' && $c7cbf49b89c34667$var$styles.none,
            (0, $1bHXt.cx)(className, xcss, '-control')
        ]),
        style: css,
        ...innerProps,
        "aria-disabled": isDisabled || undefined,
        children: children
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $c7cbf49b89c34667$export$2e2bcd8739ae039 = $c7cbf49b89c34667$var$Control;
module.exports["css"] = $c7cbf49b89c34667$export$dbf350e5966cf602;
module.exports["default"] = $c7cbf49b89c34667$export$2e2bcd8739ae039;

});

parcelRegister("fPe0U", function(module, exports) {
/* group.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1bHXt = parcelRequire("1bHXt");


var $A6wna = parcelRequire("A6wna");

const $1a73b6f9808ffda5$var$styles = {
    root: "_n3tdu2gc _ca0qu2gc"
};
const $1a73b6f9808ffda5$export$b6794329c1460634 = ()=>({});
const $1a73b6f9808ffda5$var$Group = (props)=>{
    const { children: children, cx: builtinCX, getStyles: getStyles, getClassNames: getClassNames, Heading: Heading, headingProps: headingProps, innerProps: innerProps, label: label, selectProps: selectProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $A6wna.getStyleProps)(props, 'group', {
        group: true
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: css,
        ...innerProps,
        className: (0, $gMc0m.default)([
            $1a73b6f9808ffda5$var$styles.root,
            (0, $1bHXt.cx)(className, xcss, innerProps?.className, '-Group')
        ]),
        children: [
            label && /*#__PURE__*/ (0, $l998X.jsx)(Heading, {
                ...headingProps,
                selectProps: selectProps,
                getStyles: getStyles,
                getClassNames: getClassNames,
                cx: builtinCX,
                children: label
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                children: children
            })
        ]
    });
};
const $1a73b6f9808ffda5$var$headingStyles = null;
const $1a73b6f9808ffda5$export$e5a7fbb542efcb7d = ()=>({}); // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $1a73b6f9808ffda5$export$85c8b41a3cd87edc = (props)=>{
    const { xcss: xcss } = props;
    const { data: data, ...innerProps } = (0, $A6wna.cleanCommonProps)(props);
    const { css: css, className: className } = (0, $A6wna.getStyleProps)(props, 'groupHeading', {
        'group-heading': true
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/ui-styling-standard/local-cx-xcss, @compiled/local-cx-xcss
    , {
        className: (0, $gMc0m.default)([
            "_11c8wadc _1e0c1ule _syazazsu _80om73ad _k48pwu06 _6rthpd1z _y4tiutpp _bozgutpp _1p1dglyw",
            (0, $1bHXt.cx)(className, xcss, '-group')
        ]),
        style: css,
        ...innerProps
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $1a73b6f9808ffda5$export$2e2bcd8739ae039 = $1a73b6f9808ffda5$var$Group;
module.exports["groupCSS"] = $1a73b6f9808ffda5$export$b6794329c1460634;
module.exports["groupHeadingCSS"] = $1a73b6f9808ffda5$export$e5a7fbb542efcb7d;
module.exports["GroupHeading"] = $1a73b6f9808ffda5$export$85c8b41a3cd87edc;
module.exports["default"] = $1a73b6f9808ffda5$export$2e2bcd8739ae039;

});

parcelRegister("bX0kj", function(module, exports) {
/* indicators.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1bHXt = parcelRequire("1bHXt");


var $ghftu = parcelRequire("ghftu");


var $7yDmn = parcelRequire("7yDmn");


var $u9agA = parcelRequire("u9agA");

var $fVUfS = parcelRequire("fVUfS");


var $9hlns = parcelRequire("9hlns");


var $A6wna = parcelRequire("A6wna");

// Dropdown & Clear Icons
// ==============================
const $f3b0780a6703beee$var$iconContainerStyles = {
    root: "_kkk2n7od _12ji1r31 _1qu219ly _12y31o36 _1e0c1txw _4cvr1h6o _1bah1h6o _1q51v77o _y4tiv77o _85i5v77o _bozgv77o"
};
const $f3b0780a6703beee$var$dropdownWrapperStyles = {
    root: "_1q5112x7 _y4ti12x7 _85i512x7 _bozg12x7"
}; // ==============================
const $f3b0780a6703beee$var$dropdownStyles = {
    default: "_v564vrg3 _1e0c1txw _syazazsu _1q5112x7 _y4tiv77o _85i512x7 _bozgv77o _30l3azsu",
    compact: "_1q51idpf _85i5idpf",
    disabled: "_syaz1gmx"
};
const $f3b0780a6703beee$export$e1687335805e1230 = ()=>({}); // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $f3b0780a6703beee$export$ec98719d3db7f2e4 = (props)=>{
    const { innerProps: innerProps, children: children, isDisabled: isDisabled, isCompact: isCompact, xcss: xcss } = props;
    const { css: css, className: className } = (0, $A6wna.getStyleProps)(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: css,
        className: (0, $gMc0m.default)([
            $f3b0780a6703beee$var$dropdownStyles.default,
            isDisabled && $f3b0780a6703beee$var$dropdownStyles.disabled,
            isCompact && $f3b0780a6703beee$var$dropdownStyles.compact,
            (0, $1bHXt.cx)(className, xcss, '-indicatorContainer')
        ]),
        ...innerProps,
        children: children ? children : /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
            as: "span",
            xcss: $f3b0780a6703beee$var$dropdownWrapperStyles.root,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                color: "currentColor",
                label: "open",
                size: "small"
            })
        })
    });
};
const $f3b0780a6703beee$export$9c0419fd944c1def = ()=>({});
const $f3b0780a6703beee$var$clearIndicatorStyles = {
    default: "_v564vrg3 _1e0c1txw _syaz1rpy _1q5112x7 _y4tiv77o _85i512x7 _bozgv77o _30l3azsu",
    compact: "_1q51idpf _85i5idpf"
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $f3b0780a6703beee$export$ecf9cf59142dd54a = (props)=>{
    const { innerProps: innerProps, clearControlLabel: clearControlLabel = 'clear', isCompact: isCompact, xcss: xcss } = props;
    const { css: css, className: className } = (0, $A6wna.getStyleProps)(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: css,
        className: (0, $gMc0m.default)([
            $f3b0780a6703beee$var$clearIndicatorStyles.default,
            isCompact && $f3b0780a6703beee$var$clearIndicatorStyles.compact,
            (0, $1bHXt.cx)(className, xcss, '-indicatorContainer')
        ]),
        ...innerProps,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
            xcss: $f3b0780a6703beee$var$iconContainerStyles.root,
            tabIndex: -1,
            "aria-label": clearControlLabel,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7yDmn))), {
                label: "",
                color: "currentColor",
                size: "small"
            })
        })
    });
}; // ==============================
const $f3b0780a6703beee$export$1d3f24cde248e6b5 = ()=>({});
const $f3b0780a6703beee$var$loadingIndicatorStyles = {
    default: "_1q5112x7 _y4tiu2gc _85i512x7 _bozgu2gc",
    compact: "_1q51idpf _85i5idpf"
};
const $f3b0780a6703beee$export$7c20be4c1d342248 = ({ innerProps: innerProps, isRtl: isRtl, size: size = 4, isCompact: isCompact, xcss: xcss, ...restProps })=>{
    const { css: css, className: className } = (0, $A6wna.getStyleProps)({
        ...restProps,
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }, 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: css,
        className: (0, $gMc0m.default)([
            $f3b0780a6703beee$var$loadingIndicatorStyles.default,
            isCompact && $f3b0780a6703beee$var$loadingIndicatorStyles.compact,
            (0, $1bHXt.cx)(className, xcss, '-loadingIndicator')
        ]),
        ...innerProps,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
            size: "small"
        })
    });
};
module.exports["dropdownIndicatorCSS"] = $f3b0780a6703beee$export$e1687335805e1230;
module.exports["DropdownIndicator"] = $f3b0780a6703beee$export$ec98719d3db7f2e4;
module.exports["clearIndicatorCSS"] = $f3b0780a6703beee$export$9c0419fd944c1def;
module.exports["ClearIndicator"] = $f3b0780a6703beee$export$ecf9cf59142dd54a;
module.exports["loadingIndicatorCSS"] = $f3b0780a6703beee$export$1d3f24cde248e6b5;
module.exports["LoadingIndicator"] = $f3b0780a6703beee$export$7c20be4c1d342248;

});

parcelRegister("9gJAx", function(module, exports) {
/* input.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1bHXt = parcelRequire("1bHXt");


var $dh538 = parcelRequire("dh538");


var $A6wna = parcelRequire("A6wna");

const $7ff29bbfbffbc74f$export$14a7781d0ca7abea = ()=>({});
const $7ff29bbfbffbc74f$var$inputStylesOld = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _1e0c1n7u _yv0e12qd _syazi7uo _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq"
};
const $7ff29bbfbffbc74f$var$inputStyles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _nd5l1sux _1mouv77o _195gv77o _1rjcv77o _kqswh2mm _1e0c1txw _yv0e12qd _syazi7uo _j8d6idpf _1av2idpf _1doyidpf _pfztidpf _uoe3idpf _1recidpf _70xridpf _1k96idpf _eq43idpf _1h9u1kw7 _ckog1yjy _1x651r31 _1nn4glyw _1rzeidpf _1yd8yh40 _aetr11ps _uy7x15vq _1qjlqvpr",
    disabled: "_3um015vq"
};
const $7ff29bbfbffbc74f$var$nativeInputStylesOld = null;
const $7ff29bbfbffbc74f$var$nativeInputStyles = null;
const $7ff29bbfbffbc74f$var$hidden = null;
const $7ff29bbfbffbc74f$var$Input = (props)=>{
    const { cx: builtinCX, value: value, xcss: xcss } = props;
    const { innerRef: innerRef, isDisabled: isDisabled, isHidden: isHidden, inputClassName: inputClassName, testId: testId, ...innerProps } = (0, $A6wna.cleanCommonProps)(props);
    const dataId = testId ? `${testId}-select--input` : null;
    const { css: css, className: className } = (0, $A6wna.getStyleProps)(props, 'input', {
        'input-container': true
    });
    if ((0, $dh538.fg)('platform_do_not_clear_input_for_multiselect')) return /*#__PURE__*/ (0, $l998X.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: css,
        className: (0, $gMc0m.default)([
            $7ff29bbfbffbc74f$var$inputStyles.root,
            isDisabled && $7ff29bbfbffbc74f$var$inputStyles.disabled,
            (0, $1bHXt.cx)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && `${dataId}-container`,
        children: /*#__PURE__*/ (0, $l998X.jsx)("input" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        , {
            className: (0, $gMc0m.default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1r04idpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _kqswstnw _syaz1kw7 _tzy4kb7n",
                isHidden && "_tzy4idpf",
                builtinCX({
                    input: true
                }, inputClassName, '-input')
            ]),
            ref: innerRef,
            disabled: isDisabled,
            "data-testid": dataId,
            ...innerProps
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: css,
        className: (0, $gMc0m.default)([
            $7ff29bbfbffbc74f$var$inputStylesOld.root,
            isDisabled && $7ff29bbfbffbc74f$var$inputStylesOld.disabled,
            (0, $1bHXt.cx)(className, xcss, '-Input')
        ]),
        "data-value": value || '',
        "data-testid": dataId && `${dataId}-container`,
        children: /*#__PURE__*/ (0, $l998X.jsx)("input" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        , {
            className: (0, $gMc0m.default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _11q7idpf _19itidpf _11c81kw7 _nd5l1yjy _12ji1r31 _1qu2glyw _12y3idpf _1bsb1osq _1ul9yh40 _syaz1kw7 _tzy4kb7n",
                isHidden && "_tzy4idpf",
                builtinCX({
                    input: true
                }, inputClassName, '-input')
            ]),
            ref: innerRef,
            disabled: isDisabled,
            "data-testid": dataId,
            ...innerProps
        })
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $7ff29bbfbffbc74f$export$2e2bcd8739ae039 = $7ff29bbfbffbc74f$var$Input;
module.exports["inputCSS"] = $7ff29bbfbffbc74f$export$14a7781d0ca7abea;
module.exports["default"] = $7ff29bbfbffbc74f$export$2e2bcd8739ae039;

});

parcelRegister("2ASIF", function(module, exports) {
/* multi-value.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1bHXt = parcelRequire("1bHXt");


var $hmuev = parcelRequire("hmuev");


var $A6wna = parcelRequire("A6wna");

const $280e2de5ed2817ab$var$multiValueStyles = {
    root: "_2rko12b0 _1h6d14je _1dqonqa1 _189ee4h9 _1e0c1txw _1ul9ze3t _1pfhv77o _12l2v77o _6rthv77o _ahbqv77o _bfhk1j9a _p12f1osq _syazi7uo _3yq3glyw",
    disabled: "_syaz1gmx _bfhki8nm",
    focused: "_syaz6x5g _bfhk15s3 _16qs1xv8 _1aewe4h9 _6up51j28 _1xdnnqa1"
};
const $280e2de5ed2817ab$export$23c213f7717186af = ()=>({});
const $280e2de5ed2817ab$export$f40612612e0af964 = ()=>({});
const $280e2de5ed2817ab$var$multiValueLabelStyles = {
    root: "_1reo15vq _18m915vq _2rkolb4i _11c8fhey _o5721q9c _y4tiv77o _bozg1b66 _syaz1kw7",
    disabled: "_syaz1gmx",
    ellipsis: "_1bto1l2s"
};
const $280e2de5ed2817ab$export$283467f6c4ac142b = ()=>({});
const $280e2de5ed2817ab$var$multiValueRemoveStyles = {
    focused: "_bfhkb1q9 _lswu6x5g",
    root: "_19itglyw _2rko12b0 _4cvr1h6o _1bah1h6o _1wpz1h6o _r06hglyw _bfhksm61 _syazi7uo _1e0c1txw _lswui7uo _1q51v77o _y4tiv77o _85i5v77o _bozgv77o _12l2v77o _1ah312gs _irr31dpa _13br1tmw _1di6fcek _i5f81tmw"
};
const $280e2de5ed2817ab$export$cf9cf2a30a59265c = ({ children: children, innerProps: innerProps, isFocused: isFocused, isDisabled: isDisabled, className: className, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        ...innerProps,
        className: (0, $gMc0m.default)([
            $280e2de5ed2817ab$var$multiValueStyles.root,
            isDisabled && $280e2de5ed2817ab$var$multiValueStyles.disabled,
            isFocused && $280e2de5ed2817ab$var$multiValueStyles.focused,
            (0, $1bHXt.cx)(className, xcss, '-multiValue')
        ]),
        children: children
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $280e2de5ed2817ab$export$544aeea2a5ce08ee = ({ children: children, innerProps: innerProps, isDisabled: isDisabled, hasEllipsis: hasEllipsis, className: className, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        ...innerProps,
        className: (0, $gMc0m.default)([
            $280e2de5ed2817ab$var$multiValueLabelStyles.root,
            isDisabled && $280e2de5ed2817ab$var$multiValueLabelStyles.disabled,
            hasEllipsis && $280e2de5ed2817ab$var$multiValueLabelStyles.ellipsis,
            (0, $1bHXt.cx)(className, xcss, '-MultiValueLabel')
        ]),
        children: children
    });
};
const $280e2de5ed2817ab$var$disabledStyles = null;
const $280e2de5ed2817ab$var$enabledStyles = null;
function $280e2de5ed2817ab$export$8e1fd1a40e7a2f4a({ isDisabled: isDisabled, isFocused: isFocused, innerProps: innerProps, className: className, xcss: xcss }) {
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        ...innerProps,
        className: (0, $gMc0m.default)([
            $280e2de5ed2817ab$var$multiValueRemoveStyles.root,
            isFocused && $280e2de5ed2817ab$var$multiValueRemoveStyles.focused,
            (0, $1bHXt.cx)(className, xcss, '-MultiValueRemove')
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon',
            className: (0, $gMc0m.default)([
                isDisabled && "_1e0cglyw",
                !isDisabled && "_1e0c1kw7"
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                label: "",
                color: "currentColor",
                size: "small"
            })
        })
    });
}
const $280e2de5ed2817ab$var$MultiValue = (props)=>{
    const { children: children, components: components, data: data, innerProps: innerProps, isDisabled: isDisabled, isFocused: isFocused, removeProps: removeProps, selectProps: selectProps, cropWithEllipsis: cropWithEllipsis } = props;
    const { Container: Container, Label: Label, Remove: Remove } = components;
    const ariaLabel = typeof children === 'string' ? children : data.label;
    const { css: containerCss, className: containerClassName } = (0, $A6wna.getStyleProps)(props, 'multiValue', {
        'multi-value': true,
        'multi-value--is-disabled': isDisabled
    });
    const { css: labelCss, className: labelClassName } = (0, $A6wna.getStyleProps)(props, 'multiValueLabel', {
        'multi-value__label': true
    });
    const { css: removeCss, className: removeClassName } = (0, $A6wna.getStyleProps)(props, 'multiValueRemove', {
        'multi-value__remove': true
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)(Container, {
        data: data,
        innerProps: {
            style: containerCss,
            className: containerClassName,
            ...innerProps
        },
        className: containerClassName,
        isFocused: isFocused,
        isDisabled: isDisabled,
        selectProps: selectProps,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)(Label, {
                data: data,
                innerProps: {
                    style: labelCss,
                    className: labelClassName
                },
                className: labelClassName,
                hasEllipsis: cropWithEllipsis || cropWithEllipsis === undefined,
                selectProps: selectProps,
                children: children
            }),
            /*#__PURE__*/ (0, $l998X.jsx)(Remove, {
                data: data,
                innerProps: {
                    style: removeCss,
                    className: removeClassName,
                    role: 'button',
                    tabIndex: -1,
                    'aria-label': `${ariaLabel || 'option'}, remove`,
                    ...removeProps
                },
                className: removeClassName,
                isDisabled: isDisabled,
                selectProps: selectProps
            })
        ]
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $280e2de5ed2817ab$export$2e2bcd8739ae039 = $280e2de5ed2817ab$var$MultiValue;
module.exports["multiValueCSS"] = $280e2de5ed2817ab$export$23c213f7717186af;
module.exports["multiValueLabelCSS"] = $280e2de5ed2817ab$export$f40612612e0af964;
module.exports["multiValueRemoveCSS"] = $280e2de5ed2817ab$export$283467f6c4ac142b;
module.exports["MultiValueContainer"] = $280e2de5ed2817ab$export$cf9cf2a30a59265c;
module.exports["MultiValueLabel"] = $280e2de5ed2817ab$export$544aeea2a5ce08ee;
module.exports["MultiValueRemove"] = $280e2de5ed2817ab$export$8e1fd1a40e7a2f4a;
module.exports["default"] = $280e2de5ed2817ab$export$2e2bcd8739ae039;

});

parcelRegister("4K6SB", function(module, exports) {
/* option.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1bHXt = parcelRequire("1bHXt");


var $A6wna = parcelRequire("A6wna");

const $62b8d5f515c5e7a2$export$ef897119b7e920ba = ()=>({});
const $62b8d5f515c5e7a2$var$optionStyles = {
    root: "_1rjc12x7 _18zrutpp _syazi7uo _80om73ad _1e0c1ule _1wyb1kw7 _1bsb1osq _uiztglyw _18ql1j7p _1di6fcek",
    disabled: "_syaz1gmx _80om13gf _bfhk1j28 _16qsglyw _1di61j28 _112eglyw",
    focused: "_bfhk1dpa _16qs1x9r _112e5u6v",
    selected: "_syaz6x5g _bfhk15s3 _16qs1x9r _1di6nozp _112e5u6v",
    focusedSelected: "_bfhkufnl"
};
const $62b8d5f515c5e7a2$var$Option = (props)=>{
    const { children: children, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, innerRef: innerRef, innerProps: innerProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $A6wna.getStyleProps)(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: css,
        className: (0, $gMc0m.default)([
            $62b8d5f515c5e7a2$var$optionStyles.root,
            isFocused && $62b8d5f515c5e7a2$var$optionStyles.focused,
            isSelected && $62b8d5f515c5e7a2$var$optionStyles.selected,
            isFocused && isSelected && $62b8d5f515c5e7a2$var$optionStyles.focusedSelected,
            isDisabled && $62b8d5f515c5e7a2$var$optionStyles.disabled,
            (0, $1bHXt.cx)(className, xcss, '-option')
        ]),
        ref: innerRef,
        ...innerProps,
        tabIndex: -1,
        children: children
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $62b8d5f515c5e7a2$export$2e2bcd8739ae039 = $62b8d5f515c5e7a2$var$Option;
module.exports["optionCSS"] = $62b8d5f515c5e7a2$export$ef897119b7e920ba;
module.exports["default"] = $62b8d5f515c5e7a2$export$2e2bcd8739ae039;

});

parcelRegister("hsH3d", function(module, exports) {
/* placeholder.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1bHXt = parcelRequire("1bHXt");


var $A6wna = parcelRequire("A6wna");

const $1153562350781597$export$5f3ffacd6594d90f = ()=>({});
const $1153562350781597$var$placeholderStyles = {
    root: "_nd5l1sux _19pkidpf _2hwxv77o _otyridpf _18u0v77o _syaz1rpy",
    disabled: "_syaz1gmx"
};
const $1153562350781597$var$Placeholder = (props)=>{
    const { children: children, innerProps: innerProps, isDisabled: isDisabled, xcss: xcss } = props;
    const { css: css, className: className } = (0, $A6wna.getStyleProps)(props, 'placeholder', {
        placeholder: true
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: css,
        className: (0, $gMc0m.default)([
            $1153562350781597$var$placeholderStyles.root,
            isDisabled && $1153562350781597$var$placeholderStyles.disabled,
            (0, $1bHXt.cx)(className, xcss, '-placeholder')
        ]),
        ...innerProps,
        children: children
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $1153562350781597$export$2e2bcd8739ae039 = $1153562350781597$var$Placeholder;
module.exports["placeholderCSS"] = $1153562350781597$export$5f3ffacd6594d90f;
module.exports["default"] = $1153562350781597$export$2e2bcd8739ae039;

});

parcelRegister("hf117", function(module, exports) {
/* single-value.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1bHXt = parcelRequire("1bHXt");


var $A6wna = parcelRequire("A6wna");

const $e74d5d34f7141b15$export$dbf350e5966cf602 = ()=>({});
const $e74d5d34f7141b15$var$styles = {
    root: "_nd5l1sux _1reo15vq _18m915vq _p12f1osq _1bto1l2s _o5721q9c _19pkidpf _2hwxv77o _otyridpf _18u0v77o _syazi7uo",
    disalbed: "_syaz1gmx"
};
const $e74d5d34f7141b15$var$SingleValue = (props)=>{
    const { children: children, isDisabled: isDisabled, innerProps: innerProps, xcss: xcss } = props;
    const { css: css, className: className } = (0, $A6wna.getStyleProps)(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    , {
        style: css,
        className: (0, $gMc0m.default)([
            $e74d5d34f7141b15$var$styles.root,
            isDisabled && $e74d5d34f7141b15$var$styles.disalbed,
            (0, $1bHXt.cx)(className, xcss, '-singleValue')
        ]),
        ...innerProps,
        children: children
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $e74d5d34f7141b15$export$2e2bcd8739ae039 = $e74d5d34f7141b15$var$SingleValue;
module.exports["css"] = $e74d5d34f7141b15$export$dbf350e5966cf602;
module.exports["default"] = $e74d5d34f7141b15$export$2e2bcd8739ae039;

});

parcelRegister("lGw97", function(module, exports) {

var $dpFTq = parcelRequire("dpFTq");
var $hQK6j = parcelRequire("hQK6j");





var $43qiz = parcelRequire("43qiz");

function $fc9674c81262828e$var$getCssDimensions(element) {
    const css = (0, $43qiz.getComputedStyle)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $43qiz.isHTMLElement)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $hQK6j.round)(width) !== offsetWidth || (0, $hQK6j.round)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $fc9674c81262828e$var$unwrapElement(element) {
    return !(0, $43qiz.isElement)(element) ? element.contextElement : element;
}
function $fc9674c81262828e$var$getScale(element) {
    const domElement = $fc9674c81262828e$var$unwrapElement(element);
    if (!(0, $43qiz.isHTMLElement)(domElement)) return (0, $hQK6j.createCoords)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $fc9674c81262828e$var$getCssDimensions(domElement);
    let x = ($ ? (0, $hQK6j.round)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $hQK6j.round)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $fc9674c81262828e$var$noOffsets = /*#__PURE__*/ (0, $hQK6j.createCoords)(0);
function $fc9674c81262828e$var$getVisualOffsets(element) {
    const win = (0, $43qiz.getWindow)(element);
    if (!(0, $43qiz.isWebKit)() || !win.visualViewport) return $fc9674c81262828e$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $fc9674c81262828e$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $43qiz.getWindow)(element)) return false;
    return isFixed;
}
function $fc9674c81262828e$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $fc9674c81262828e$var$unwrapElement(element);
    let scale = (0, $hQK6j.createCoords)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $43qiz.isElement)(offsetParent)) scale = $fc9674c81262828e$var$getScale(offsetParent);
        } else scale = $fc9674c81262828e$var$getScale(element);
    }
    const visualOffsets = $fc9674c81262828e$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $fc9674c81262828e$var$getVisualOffsets(domElement) : (0, $hQK6j.createCoords)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $43qiz.getWindow)(domElement);
        const offsetWin = offsetParent && (0, $43qiz.isElement)(offsetParent) ? (0, $43qiz.getWindow)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $43qiz.getFrameElement)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $fc9674c81262828e$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $43qiz.getComputedStyle)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $43qiz.getWindow)(currentIFrame);
            currentIFrame = (0, $43qiz.getFrameElement)(currentWin);
        }
    }
    return (0, $hQK6j.rectToClientRect)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $fc9674c81262828e$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $43qiz.getNodeScroll)(element).scrollLeft;
    if (!rect) return $fc9674c81262828e$var$getBoundingClientRect((0, $43qiz.getDocumentElement)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $fc9674c81262828e$var$getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
    if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : // RTL <body> scrollbar.
    $fc9674c81262828e$var$getWindowScrollBarX(documentElement, htmlRect));
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $fc9674c81262828e$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $43qiz.getDocumentElement)(offsetParent);
    const topLayer = elements ? (0, $43qiz.isTopLayer)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $hQK6j.createCoords)(1);
    const offsets = (0, $hQK6j.createCoords)(0);
    const isOffsetParentAnElement = (0, $43qiz.isHTMLElement)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $43qiz.getNodeName)(offsetParent) !== 'body' || (0, $43qiz.isOverflowElement)(documentElement)) scroll = (0, $43qiz.getNodeScroll)(offsetParent);
        if ((0, $43qiz.isHTMLElement)(offsetParent)) {
            const offsetRect = $fc9674c81262828e$var$getBoundingClientRect(offsetParent);
            scale = $fc9674c81262828e$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $fc9674c81262828e$var$getHTMLOffset(documentElement, scroll, true) : (0, $hQK6j.createCoords)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $fc9674c81262828e$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $fc9674c81262828e$var$getDocumentRect(element) {
    const html = (0, $43qiz.getDocumentElement)(element);
    const scroll = (0, $43qiz.getNodeScroll)(element);
    const body = element.ownerDocument.body;
    const width = (0, $hQK6j.max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $hQK6j.max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $fc9674c81262828e$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $43qiz.getComputedStyle)(body).direction === 'rtl') x += (0, $hQK6j.max)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $fc9674c81262828e$var$getViewportRect(element, strategy) {
    const win = (0, $43qiz.getWindow)(element);
    const html = (0, $43qiz.getDocumentElement)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $43qiz.isWebKit)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
const $fc9674c81262828e$var$absoluteOrFixed = /*#__PURE__*/ new Set([
    'absolute',
    'fixed'
]);
// Returns the inner client rect, subtracting scrollbars if present.
function $fc9674c81262828e$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $fc9674c81262828e$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $43qiz.isHTMLElement)(element) ? $fc9674c81262828e$var$getScale(element) : (0, $hQK6j.createCoords)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $fc9674c81262828e$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $fc9674c81262828e$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $fc9674c81262828e$var$getDocumentRect((0, $43qiz.getDocumentElement)(element));
    else if ((0, $43qiz.isElement)(clippingAncestor)) rect = $fc9674c81262828e$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $fc9674c81262828e$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $hQK6j.rectToClientRect)(rect);
}
function $fc9674c81262828e$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $43qiz.getParentNode)(element);
    if (parentNode === stopNode || !(0, $43qiz.isElement)(parentNode) || (0, $43qiz.isLastTraversableNode)(parentNode)) return false;
    return (0, $43qiz.getComputedStyle)(parentNode).position === 'fixed' || $fc9674c81262828e$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $fc9674c81262828e$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $43qiz.getOverflowAncestors)(element, [], false).filter((el)=>(0, $43qiz.isElement)(el) && (0, $43qiz.getNodeName)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $43qiz.getComputedStyle)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $43qiz.getParentNode)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $43qiz.isElement)(currentNode) && !(0, $43qiz.isLastTraversableNode)(currentNode)){
        const computedStyle = (0, $43qiz.getComputedStyle)(currentNode);
        const currentNodeIsContaining = (0, $43qiz.isContainingBlock)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && $fc9674c81262828e$var$absoluteOrFixed.has(currentContainingBlockComputedStyle.position) || (0, $43qiz.isOverflowElement)(currentNode) && !currentNodeIsContaining && $fc9674c81262828e$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $43qiz.getParentNode)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $fc9674c81262828e$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $43qiz.isTopLayer)(element) ? [] : $fc9674c81262828e$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $fc9674c81262828e$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $hQK6j.max)(rect.top, accRect.top);
        accRect.right = (0, $hQK6j.min)(rect.right, accRect.right);
        accRect.bottom = (0, $hQK6j.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $hQK6j.max)(rect.left, accRect.left);
        return accRect;
    }, $fc9674c81262828e$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $fc9674c81262828e$var$getDimensions(element) {
    const { width: width, height: height } = $fc9674c81262828e$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $fc9674c81262828e$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $43qiz.isHTMLElement)(offsetParent);
    const documentElement = (0, $43qiz.getDocumentElement)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $fc9674c81262828e$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $hQK6j.createCoords)(0);
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    function setLeftRTLScrollbarOffset() {
        offsets.x = $fc9674c81262828e$var$getWindowScrollBarX(documentElement);
    }
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $43qiz.getNodeName)(offsetParent) !== 'body' || (0, $43qiz.isOverflowElement)(documentElement)) scroll = (0, $43qiz.getNodeScroll)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $fc9674c81262828e$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) setLeftRTLScrollbarOffset();
    }
    if (isFixed && !isOffsetParentAnElement && documentElement) setLeftRTLScrollbarOffset();
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $fc9674c81262828e$var$getHTMLOffset(documentElement, scroll) : (0, $hQK6j.createCoords)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $fc9674c81262828e$var$isStaticPositioned(element) {
    return (0, $43qiz.getComputedStyle)(element).position === 'static';
}
function $fc9674c81262828e$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $43qiz.isHTMLElement)(element) || (0, $43qiz.getComputedStyle)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $43qiz.getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $fc9674c81262828e$var$getOffsetParent(element, polyfill) {
    const win = (0, $43qiz.getWindow)(element);
    if ((0, $43qiz.isTopLayer)(element)) return win;
    if (!(0, $43qiz.isHTMLElement)(element)) {
        let svgOffsetParent = (0, $43qiz.getParentNode)(element);
        while(svgOffsetParent && !(0, $43qiz.isLastTraversableNode)(svgOffsetParent)){
            if ((0, $43qiz.isElement)(svgOffsetParent) && !$fc9674c81262828e$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $43qiz.getParentNode)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $fc9674c81262828e$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $43qiz.isTableElement)(offsetParent) && $fc9674c81262828e$var$isStaticPositioned(offsetParent))offsetParent = $fc9674c81262828e$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $43qiz.isLastTraversableNode)(offsetParent) && $fc9674c81262828e$var$isStaticPositioned(offsetParent) && !(0, $43qiz.isContainingBlock)(offsetParent)) return win;
    return offsetParent || (0, $43qiz.getContainingBlock)(element) || win;
}
const $fc9674c81262828e$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $fc9674c81262828e$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $fc9674c81262828e$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $fc9674c81262828e$var$isRTL(element) {
    return (0, $43qiz.getComputedStyle)(element).direction === 'rtl';
}
const $fc9674c81262828e$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $fc9674c81262828e$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $43qiz.getDocumentElement,
    getClippingRect: $fc9674c81262828e$var$getClippingRect,
    getOffsetParent: $fc9674c81262828e$var$getOffsetParent,
    getElementRects: $fc9674c81262828e$var$getElementRects,
    getClientRects: $fc9674c81262828e$var$getClientRects,
    getDimensions: $fc9674c81262828e$var$getDimensions,
    getScale: $fc9674c81262828e$var$getScale,
    isElement: $43qiz.isElement,
    isRTL: $fc9674c81262828e$var$isRTL
};
function $fc9674c81262828e$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $fc9674c81262828e$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $43qiz.getDocumentElement)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $hQK6j.floor)(top);
        const insetRight = (0, $hQK6j.floor)(root.clientWidth - (left + width));
        const insetBottom = (0, $hQK6j.floor)(root.clientHeight - (top + height));
        const insetLeft = (0, $hQK6j.floor)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $hQK6j.max)(0, (0, $hQK6j.min)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !$fc9674c81262828e$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $fc9674c81262828e$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $fc9674c81262828e$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $43qiz.getOverflowAncestors)(referenceEl) : [],
        ...(0, $43qiz.getOverflowAncestors)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $fc9674c81262828e$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $fc9674c81262828e$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $fc9674c81262828e$var$getBoundingClientRect(reference);
        if (prevRefRect && !$fc9674c81262828e$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $fc9674c81262828e$export$37b6bde19b108ecc = (0, $dpFTq.detectOverflow);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $fc9674c81262828e$export$cc800923e997bb8 = (0, $dpFTq.offset);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $fc9674c81262828e$export$91fb6ecbd551914 = (0, $dpFTq.autoPlacement);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $fc9674c81262828e$export$fba63a578e423eb = (0, $dpFTq.shift);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $fc9674c81262828e$export$8a83211c878a3f1f = (0, $dpFTq.flip);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $fc9674c81262828e$export$346677f925de839c = (0, $dpFTq.size);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $fc9674c81262828e$export$fe8985bb6374093c = (0, $dpFTq.hide);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $fc9674c81262828e$export$f2120bbfa5450bd2 = (0, $dpFTq.arrow);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $fc9674c81262828e$export$18c8ad048e32c7d5 = (0, $dpFTq.inline);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $fc9674c81262828e$export$7bf07e38f3dc4b69 = (0, $dpFTq.limitShift);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $fc9674c81262828e$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $fc9674c81262828e$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $dpFTq.computePosition)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};
module.exports["autoUpdate"] = $fc9674c81262828e$export$deee3a793edee05f;

});

parcelRegister("dpFTq", function(module, exports) {
$parcel$export(module.exports, "rectToClientRect", () => (parcelRequire("hQK6j")).rectToClientRect);

var $hQK6j = parcelRequire("hQK6j");

function $9c3e1b3e533fca3f$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $hQK6j.getSideAxis)(placement);
    const alignmentAxis = (0, $hQK6j.getAlignmentAxis)(placement);
    const alignLength = (0, $hQK6j.getAxisLength)(alignmentAxis);
    const side = (0, $hQK6j.getSide)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $hQK6j.getAlignment)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $9c3e1b3e533fca3f$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $9c3e1b3e533fca3f$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $9c3e1b3e533fca3f$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $9c3e1b3e533fca3f$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $hQK6j.evaluate)(options, state);
    const paddingObject = (0, $hQK6j.getPaddingObject)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $hQK6j.rectToClientRect)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $hQK6j.rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $9c3e1b3e533fca3f$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $hQK6j.evaluate)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $hQK6j.getPaddingObject)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $hQK6j.getAlignmentAxis)(placement);
            const length = (0, $hQK6j.getAxisLength)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $hQK6j.min)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $hQK6j.min)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $hQK6j.clamp)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $hQK6j.getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $9c3e1b3e533fca3f$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $hQK6j.getAlignment)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $hQK6j.getAlignment)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $hQK6j.getSide)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $hQK6j.getAlignment)(placement) === alignment || (autoAlignment ? (0, $hQK6j.getOppositeAlignmentPlacement)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $9c3e1b3e533fca3f$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $hQK6j.placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $hQK6j.evaluate)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $hQK6j.placements) ? $9c3e1b3e533fca3f$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $9c3e1b3e533fca3f$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $hQK6j.getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $hQK6j.getSide)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $hQK6j.getAlignment)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $hQK6j.getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $9c3e1b3e533fca3f$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $hQK6j.evaluate)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $hQK6j.getSide)(placement);
            const initialSideAxis = (0, $hQK6j.getSideAxis)(initialPlacement);
            const isBasePlacement = (0, $hQK6j.getSide)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $hQK6j.getOppositePlacement)(initialPlacement)
            ] : (0, $hQK6j.getExpandedPlacements)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $hQK6j.getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $9c3e1b3e533fca3f$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $hQK6j.getAlignmentSides)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) {
                    const ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== (0, $hQK6j.getSideAxis)(nextPlacement) : false;
                    if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
                    // overflows the main axis.
                    overflowsData.every((d)=>(0, $hQK6j.getSideAxis)(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) // Try next placement and re-run the lifecycle.
                    return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                }
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $hQK6j.getSideAxis)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $9c3e1b3e533fca3f$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $9c3e1b3e533fca3f$var$isAnySideFullyClipped(overflow) {
    return (0, $hQK6j.sides).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $9c3e1b3e533fca3f$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, $hQK6j.evaluate)(options, state);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await $9c3e1b3e533fca3f$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: 'reference'
                        });
                        const offsets = $9c3e1b3e533fca3f$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $9c3e1b3e533fca3f$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await $9c3e1b3e533fca3f$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $9c3e1b3e533fca3f$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $9c3e1b3e533fca3f$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $9c3e1b3e533fca3f$var$getBoundingRect(rects) {
    const minX = (0, $hQK6j.min)(...rects.map((rect)=>rect.left));
    const minY = (0, $hQK6j.min)(...rects.map((rect)=>rect.top));
    const maxX = (0, $hQK6j.max)(...rects.map((rect)=>rect.right));
    const maxY = (0, $hQK6j.max)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $9c3e1b3e533fca3f$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $hQK6j.rectToClientRect)($9c3e1b3e533fca3f$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $9c3e1b3e533fca3f$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $hQK6j.evaluate)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $9c3e1b3e533fca3f$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $hQK6j.rectToClientRect)($9c3e1b3e533fca3f$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $hQK6j.getPaddingObject)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $hQK6j.getSideAxis)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $hQK6j.getSide)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $hQK6j.getSide)(placement) === 'left';
                    const maxRight = (0, $hQK6j.max)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $hQK6j.min)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
const $9c3e1b3e533fca3f$var$originSides = /*#__PURE__*/ new Set([
    'left',
    'top'
]);
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $9c3e1b3e533fca3f$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $hQK6j.getSide)(placement);
    const alignment = (0, $hQK6j.getAlignment)(placement);
    const isVertical = (0, $hQK6j.getSideAxis)(placement) === 'y';
    const mainAxisMulti = $9c3e1b3e533fca3f$var$originSides.has(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $hQK6j.evaluate)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $9c3e1b3e533fca3f$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $9c3e1b3e533fca3f$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $9c3e1b3e533fca3f$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $hQK6j.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $9c3e1b3e533fca3f$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $hQK6j.getSideAxis)((0, $hQK6j.getSide)(placement));
            const mainAxis = (0, $hQK6j.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $hQK6j.clamp)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $hQK6j.clamp)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $9c3e1b3e533fca3f$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $hQK6j.evaluate)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $hQK6j.getSideAxis)(placement);
            const mainAxis = (0, $hQK6j.getOppositeAxis)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $hQK6j.evaluate)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = $9c3e1b3e533fca3f$var$originSides.has((0, $hQK6j.getSide)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $9c3e1b3e533fca3f$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $hQK6j.evaluate)(options, state);
            const overflow = await $9c3e1b3e533fca3f$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $hQK6j.getSide)(placement);
            const alignment = (0, $hQK6j.getAlignment)(placement);
            const isYAxis = (0, $hQK6j.getSideAxis)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $hQK6j.min)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $hQK6j.min)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $hQK6j.max)(overflow.left, 0);
                const xMax = (0, $hQK6j.max)(overflow.right, 0);
                const yMin = (0, $hQK6j.max)(overflow.top, 0);
                const yMax = (0, $hQK6j.max)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $hQK6j.max)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $hQK6j.max)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};
module.exports["computePosition"] = $9c3e1b3e533fca3f$export$48a53dcb22e581d0;
module.exports["detectOverflow"] = $9c3e1b3e533fca3f$export$37b6bde19b108ecc;
module.exports["arrow"] = $9c3e1b3e533fca3f$export$f2120bbfa5450bd2;
module.exports["autoPlacement"] = $9c3e1b3e533fca3f$export$91fb6ecbd551914;
module.exports["flip"] = $9c3e1b3e533fca3f$export$8a83211c878a3f1f;
module.exports["hide"] = $9c3e1b3e533fca3f$export$fe8985bb6374093c;
module.exports["inline"] = $9c3e1b3e533fca3f$export$18c8ad048e32c7d5;
module.exports["offset"] = $9c3e1b3e533fca3f$export$cc800923e997bb8;
module.exports["shift"] = $9c3e1b3e533fca3f$export$fba63a578e423eb;
module.exports["limitShift"] = $9c3e1b3e533fca3f$export$7bf07e38f3dc4b69;
module.exports["size"] = $9c3e1b3e533fca3f$export$346677f925de839c;

});


$parcel$global.rlb("kUbUu")
//# sourceMappingURL=manual-triggers-modal.04741f76.js.map
